// noinspection SqlDialectInspection

// User-visible labels: buttons, field labels, titles, column headers.
// One flat alphabetical block on purpose — most keys ("Name", "Status",
// "Add") belong to no domain, and the value-first lookup workflow depends
// on being able to grep this file for a literal and insert alphabetically.

export const Labels = {
    Access: "Access",
    AccessTokenUrl: "Access token URL",
    AccessUntil: "Access until",
    Account: "Account",
    AccountCancelled: "Account cancelled",
    AccountCategory: "Account category",
    AccountId: "Account ID",
    AccountName: "Account name",
    AccountRange: "Account range",
    AccountSettings: "Account settings",
    AccountTemplate: "Account template",
    AccountUsage: "Account usage",
    AccountUser: "Account user",
    Action: "Action",
    ActionDetails: "Action details",
    ActionError: "Action error",
    ActionFields: "Action fields",
    ActionFieldSettings: "Action field settings",
    ActionRuleSettings: "Action rule settings",
    ActionSettings: "Action settings",
    ActionType: "Action type",
    Actions: "Actions",
    Activate: "Activate",
    Active: "Active",
    ActivePlan: "Active plan",
    ActiveUsers: "Active users",
    AdaptiveCards: "Adaptive cards",
    AdaptiveCardTemplates: "Adaptive card templates",
    Add: "Add",
    AddABlock: "Add a block",
    AddACalculatedParameter: "Add a calculated parameter",
    AddAChildCompany: "Add a child company",
    AddAClientInstruction: "Add a client instruction",
    AddAColor: "Add a color",
    AddAColumn: "Add a column",
    AddACondition: "Add a condition",
    AddActionField: "Add action field",
    AddAccountUser: "Add an account user",
    AddAdaptiveCard: "Add adaptive card",
    AddADetail: "Add a detail",
    AddADomain: "Add a domain",
    AddAField: "Add a field",
    AddAGroup: "Add a group",
    AddAiChatWidget: "Add AI chat widget",
    AddAiModel: "Add AI model",
    AddAiModel2: "Add an AI model",
    AddAiPromptList: "Add AI prompt list",
    AddAiPromptWidget: "Add AI prompt widget",
    AddAiSummary: "Add an AI summary",
    AddAiToneModifier: "Add AI tone modifier",
    AddAiToneModifier2: "Add an AI tone modifier",
    AddAList: "Add a list",
    AddAllDefaultFields: "Add all default fields",
    AddAnAction: "Add an action",
    AddAnAllowedFileType: "Add an allowed file type",
    AddAnAttachment: "Add an attachment",
    AddAnIpAddress: "Add an IP address",
    AddAnMcpClient: "Add an MCP client",
    AddAnotherRow: "Add another row",
    AddAParameter: "Add a parameter",
    AddAppRegistration: "Add app registration",
    AddAppRegistration2: "Add an app registration",
    AddAPrompt: "Add a prompt",
    AddARestriction: "Add a restriction",
    AddARole: "Add a role",
    AddARow: "Add a row",
    AddARule: "Add a rule",
    AddAction: "Add action",
    AddActions: "Add actions",
    AddAdditionalEntity: "Add additional list",
    AddAdvancedSearchField: "Add advanced search field",
    AddAllowedFileType: "Add allowed file type",
    AddAnotherColor: "Add another color",
    AddAnotherCondition: "Add another condition",
    AddAnotherField: "Add another field",
    AddAnotherFilter: "Add another filter",
    AddAnotherRestriction: "Add another restriction",
    AddAnotherRule: "Add another rule",
    AddApiUser: "Add API user",
    AddApiUserToken: "Add an API token",
    AddApp: "Add app",
    AddAStyle: "Add a style",
    AddASummaryColumn: "Add a summary column",
    AddASummaryRow: "Add a summary row",
    AddATemplate: "Add a template",
    AddATool: "Add a tool",
    AddAttachment: "Add attachment",
    AddAUrlParameter: "Add a URL parameter",
    AddAUser: "Add a user",
    AddAValidation: "Add a validation",
    AddAVariable: "Add a variable",
    AddAWidget: "Add a widget",
    AddBaseEntityRestriction: "Add base list restriction",
    AddBaseListDetail: "Add base list detail",
    AddBlock: "Add block",
    AddBodyField: "Add body field",
    AddBorder: "Add border",
    AddCalculatedColumn: "Add a calculated column",
    AddCalculatedField: "Add calculated field",
    AddCalculatedField2: "Add a calculated field",
    AddCalculatedFields: "Add calculated fields",
    AddCalculatedParameter: "Add calculated parameter",
    AddCalculatedRow: "Add calculated row",
    AddCalculatedVariable: "Add a calculated variable",
    AddCalculatedVariable2: "Add calculated variable",
    AddCalculation: "Add calculation",
    AddCardsWidget: "Add cards widget",
    AddChildCompany: "Add child company",
    AddClientInstruction: "Add client instruction",
    AddClientMapping: "Add client mapping",
    AddClientMapping2: "Add a client mapping",
    AddClientSecret: "Add client secret",
    AddColor: "Add color",
    AddColorCodingRule: "Add color coding rule",
    AddColorCodingRule2: "Add a color coding rule",
    AddColorGradient: "Add color gradient",
    AddColorPalette: "Add color palette",
    AddColors: "Add colors",
    AddColumn: "Add column",
    AddColumns: "Add columns",
    AddCompanies: "Add companies",
    AddCompany: "Add {0}",
    AddCompanyMapping: "Add {0} mapping",
    AddCompareFromEntityRestriction: "Add compare from list restriction",
    AddCompareToEntityRestriction: "Add compare to list restriction",
    AddComparisonFields: "Add comparison fields",
    AddComparisonList: "Add comparison list",
    AddComponent: "Add component",
    AddComponent2: "Add a component",
    AddConnector: "Add connector",
    AddConnector2: "Add a connector",
    AddConnectorNamed: "Add {0} connector",
    AddCreditCard: "Add credit card",
    AddCustomAction: "Add custom action",
    AddCustomDateFilter: "Add a custom date filter",
    AddCustomDateFilter2: "Add custom date filter",
    AddCustomEntity: "Add custom list",
    AddCustomEntityCompare: "Compare lists",
    AddCustomEntityJoin: "Join lists",
    AddCustomEntityMatrix: "Summarize fields in a matrix",
    AddCustomEntityMerge: "Merge lists",
    AddCustomEntityRestriction: "Restrict data in a list",
    AddCustomEntitySummary: "Summarize a list",
    AddCustomMcpServer: "Add custom MCP server",
    AddCustomResponseHeader: "Add custom response header",
    AddDashboard: "Add dashboard",
    AddDatePart: "Add date part",
    AddDefaultColumn: "Add default column",
    AddDefaultFields: "Add default fields",
    AddDependency: "Add dependency",
    AddDetail: "Add detail",
    AddDetailField: "Add detail field",
    AddDimensions: "Add dimensions",
    AddDisplayFields: "Add display fields",
    AddDomain: "Add domain",
    AddDomainRestriction: "Add domain restriction",
    AddDynamicFilterRow: "Add a dynamic filter row",
    AddDynamicRow: "Add dynamic row",
    AddDynamicRow2: "Add a dynamic row",
    Added: "Added",
    AddElement: "Add element",
    AddEmailSignature: "Add an email signature",
    AddEmailSignature2: "Add email signature",
    AddEndpoint: "Add endpoint",
    AddEntities: "Add lists",
    AddEntity: "Add list",
    AddEntityAction: "Add list action",
    AddEnvironmentParameter: "Add environment parameter",
    AddEnvironmentParameter2: "Add an environment parameter",
    AddErrorCode: "Add error code",
    AddErrorCode2: "Add an error code",
    AddExcelTemplate: "Add an Excel template",
    AddExcelTemplate2: "Add Excel template",
    AddExistingWidget: "Add an existing widget",
    AddExistingWidget2: "Add existing widget",
    AddExtensionDependency: "Add an extension as a dependency",
    AddExternalUser: "Add external user",
    AddExternalUser2: "Add an external user",
    AddFavorite: "Add favorite",
    AddFavorite2: "Add a favorite",
    AddFavoritePrompt: "Add favorite prompt",
    AddFavoritePrompt2: "Add a favorite prompt",
    AddFavorites: "Add favorites",
    AddField: "Add field",
    AddFields: "Add fields",
    AddFieldsFromASampleFile: "Add fields from a sample file",
    AddFieldsFromFile: "Add fields from file",
    AddFieldsFromQuery: "Add fields from query",
    AddFieldsQuery: "Add fields by query",
    AddFieldsQuery2: "Add fields from a query",
    AddFile: "Add file",
    AddFileSplit: "Add file split",
    AddFileWidget: "Add file widget",
    AddFilter: "Add filter",
    AddFilterColumn: "Add filter column",
    AddFilterColumn2: "Add a filter column",
    AddFilterOnField: "Add filter on field",
    AddFilterRow: "Add filter row",
    AddFilterRow2: "Add a filter row",
    AddFilterVariable: "Add filter variable",
    AddFirewall: "Add firewall",
    AddFiscalPeriod: "Add fiscal period",
    AddFiscalPeriod2: "Add a fiscal period",
    AddFiscalYear: "Add fiscal year",
    AddFiscalYears: "Add fiscal years",
    AddFlow: "Add flow",
    AddFolder: "Add folder",
    AddForm: "Add form",
    AddFormBody: "Add form body",
    AddFormBodyField: "Add a form body field",
    AddFormItem: "Add form item",
    AddFormWidget: "Add form widget",
    AddFormWidget2: "Add a form widget",
    AddFunction: "Add function",
    AddGlobalVariable: "Add global variable",
    AddGradient: "Add gradient",
    AddGroup: "Add group",
    AddGroup2: "Add by group",
    AddGroupField: "Add group field",
    AddGroupField2: "Add a group field",
    AddHeader: "Add header",
    AddHeader2: "Add a header",
    AddHeadersSummariesEachAccount: "Add headers and summaries for each account",
    AddHiddenField: "Add hidden field",
    AddHomePageItem: "Add item to home page",
    AddIcon: "Add an icon",
    AddIcon2: "Add icon",
    AddImage: "Add image",
    AddImageWidget: "Add image widget",
    AddIndividualLists: "Add individual lists",
    AddInsight: "Add insight",
    AddIpAddress: "Add IP address",
    AddItem: "Add item",
    AddingDefaultPrompts: "Adding default prompts",
    AdditionalParameters: "Additional parameters",
    AddJob: "Add job",
    AddJoin: "Add join",
    AddJoiningFields: "Add joining fields",
    AddJoinList: "Add join list",
    AddKeyField: "Add key field",
    AddKeyField2: "Add a key field",
    AddKnowledgeBase: "Add knowledge base",
    AddKnowledgeBase2: "Add a knowledge base",
    AddLabelColumn: "Add a label column",
    AddListAction: "Add a list action",
    AddListAttachment: "Add a list attachment",
    AddListItem: "Add list item",
    AddListItems: "Add list items",
    AddListsConnector: "Add lists from connector",
    AddLookup: "Add lookup",
    AddLookup2: "Add a lookup",
    AddManagementReport: "Add a management report",
    AddMapping: "Add mapping",
    AddMatchingFields: "Add matching fields",
    AddMatrixList: "Add matrix list",
    AddMcpClient: "Add MCP client",
    AddMcpIcon: "Add MCP icon",
    AddMcpPrompt: "Add MCP prompt",
    AddMcpServer: "Add MCP server",
    AddMcpServer2: "Add an MCP server",
    AddMcpTool: "Add MCP tool",
    AddMcpWidget: "Add MCP widget",
    AddMcpWidgetTheme: "Add MCP widget theme",
    AddMergeList: "Add merge list",
    AddMessage: "Add message",
    AddMessage2: "Add a message",
    AddMobileApp: "Add mobile app",
    AddMobileApp2: "Add a mobile app",
    AddModel: "Add model",
    AddMultipleListItems: "Add multiple list items",
    AddMultipleListWidget: "Add multiple list widget",
    AddNewCardsWidget: "Add a new cards widget",
    AddNewFormWidget: "Add a new form widget",
    AddNewImageWidget: "Add a new image widget",
    AddNewItem: "Add new item",
    AddNewSearchWidget: "Add a new search widget",
    AddNewShippingWidget: "Add a new shipping widget",
    AddNewSingleListWidget: "Add a new single list widget",
    AddNewSingleRecordWidget: "Add a new single record widget",
    AddNewSummaryWidget: "Add a new summary widget",
    AddNewTab: "Add new tab",
    AddNewTile: "Add new tile",
    AddNewVersion: "Add new version",
    AddNewWidget: "Add new widget",
    AddOn: "Add-on",
    AddOnConnectorPack: "Connector pack",
    AddOnExtendedRetention: "Extended retention",
    AddOnMcpToolPack: "AI & MCP tool pack",
    AddOnUserPack: "User pack",
    AddOptimization: "Add optimization",
    AddOptimization2: "Add an optimization",
    AddOutputField: "Add an output field",
    AddOutputField2: "Add output field",
    AddPage: "Add page",
    AddParameter: "Add parameter",
    AddParameters: "Add parameters",
    AddParametersAttachment: "Add a parameters attachment",
    AddParentField: "Add parent field",
    AddParentField2: "Add a parent field",
    AddPartnerUser: "Add partner user",
    AddPaymentMethod: "Add payment method",
    AddPdfTemplate: "Add PDF template",
    AddPeriod: "Add period",
    AddPrompt: "Add prompt",
    AddPrompts: "Add prompts",
    AddPublicHoliday: "Add a public holiday",
    AddPublicHoliday2: "Add public holiday",
    AddPublicHolidays: "Add public holidays",
    AddQuery: "Add query",
    AddQuery2: "Add a query",
    AddQueryBuilderList: "Add a Query Builder list",
    AddQueryBuilderList2: "Add Query builder list",
    AddRangeOfPeriods: "Add range of periods",
    AddRecipient: "Add recipient",
    AddRecipient2: "Add a recipient",
    AddRedactionMethod: "Add redaction method",
    AddRedactionMethod2: "Add a redaction method",
    AddRedirectUri: "Add redirect URI",
    AddRelatedFields: "Add related fields",
    AddRelationship: "Add relationship",
    AddReport: "Add report",
    AddReportingTree: "Add reporting tree",
    AddReportingTreeItem: "Add a reporting tree item",
    AddReportingTreeItem2: "Add reporting tree item",
    AddResource: "Add resource",
    AddResource2: "Add a resource",
    AddResources: "Add resources",
    AddResponseField: "Add response field",
    AddRestriction: "Add restriction",
    AddRestrictionList: "Add restriction list",
    AddReturnField: "Add return field",
    AddReturnField2: "Add a return field",
    AddRole: "Add role",
    AddRow: "Add row",
    AddRows: "Add rows",
    AddRule: "Add rule",
    AddSampleFile: "Add from a sample file",
    AddSandbox: "Add sandbox",
    AddScript: "Add script",
    AddSearchField: "Add search field",
    AddSearchField2: "Add a search field",
    AddSearchWidget: "Add search widget",
    AddSecret: "Add secret",
    AddSection: "Add section",
    AddSection2: "Add a section",
    AddSecurity: "Add security to",
    AddSelected: "Add selected",
    AddSelectedColumn: "Add selected column",
    AddSelectedColumns: "Add selected columns",
    AddShippingWidget: "Add shipping widget",
    AddSidebar: "Add sidebar",
    AddSingleListWidget: "Add single list widget",
    AddSingleRecordWidget: "Add single record widget",
    AddSort: "Add sort",
    AddSorting: "Add sorting",
    AddSplitFile: "Add split file",
    AddStyle: "Add style",
    AddSubreddit: "Add subreddit",
    AddSuggestion: "Add suggestion",
    AddSummaryColumn: "Add summary column",
    AddSummaryFields: "Add summary fields",
    AddSummaryList: "Add summary list",
    AddSummaryRow: "Add summary row",
    AddSummaryWidget: "Add summary widget",
    AddSupportUser: "Add support user",
    AddSvgCard: "Add SVG card",
    AddTab: "Add tab",
    AddTab2: "Add a tab",
    AddTable: "Add table",
    AddTable2: "Add a table",
    AddTables: "Add tables",
    AddTableStyle: "Add table style",
    AddTableStyle2: "Add a table style",
    AddTag: "Add tag",
    AddTeam: "Add team",
    AddTeam2: "Add a team",
    AddTeamMapping: "Add team mapping",
    AddTeamMapping2: "Add a team mapping",
    AddTeamMember: "Add team member",
    AddTeamMembers: "Add team members",
    AddTeams: "Add teams",
    AddTemplate: "Add template",
    AddTextSearchField: "Add text search field",
    AddTheBaseListAsADetail: "Add the base list as a detail",
    AddTheme: "Add theme",
    AddTheme2: "Add a theme",
    AddThirdPartyTool: "Add third-party tool",
    AddToGroup: "Add to group",
    AddToHomePage: "Add to home page",
    AddToken2: "Add a token",
    AddTools: "Add tools",
    AddToQueue: "Add to queue",
    AddToTab: "Add to tab",
    AddToken: "Add token",
    AddTool: "Add tool",
    AddUnderHeader: "Add under header",
    AddUrl: "Add URL",
    AddUrlParameter: "Add URL parameter",
    AddUser: "Add user",
    AddUserInput: "Add a user input",
    AddUserMapping: "Add user mapping",
    AddUserMapping2: "Add a user mapping",
    AddUsers: "Add users",
    AddUserTeam: "Add the user to a team",
    AddUserVariable: "Add a user variable",
    AddUserVariable2: "Add user variable",
    AddValidation: "Add validation",
    AddValidationRule: "Add validation rule",
    AddValidationRule2: "Add a validation rule",
    AddVariable: "Add variable",
    AddVariant: "Add variant",
    AddVariant2: "Add a variant",
    AddVirtualNetwork: "Add virtual network",
    AddVirtualNetwork2: "Add a virtual network",
    AddWidget: "Add widget",
    AddWidgetFirewall: "Add widget firewall",
    AdditionalFilters: "Additional filters",
    Address: "Address",
    AddressLine1: "Address line 1",
    AddressLine2: "Address line 2",
    AddressType: "Address type",
    AddWidgetGroup: "Add widget group",
    AddWidgetGroup2: "Add a widget group",
    AddWidgetTheme: "Add a widget theme",
    AddWorksheet: "Add worksheet",
    AddWorksheet2: "Add a worksheet",
    AdHocQuerying: "Ad-hoc querying",
    Admin1: "Administrator 1",
    Admin2: "Administrator 2",
    Administration: "Administration",
    Administrator: "Administrator",
    Advanced: "Advanced",
    AdvancedSearch: "Advanced search",
    Ai: "AI",
    AiModels: "AI models",
    AiModelSettings: "AI model settings",
    AiPersonalPreferences: "AI personal preferences",
    AiProvider: "AI provider",
    AiSummary: "AI summary",
    AiToneModifier: "AI tone modifier",
    AiToneModifierDetails: "AI tone modifier details",
    AiToneModifiers: "AI tone modifiers",
    Alias: "Alias",
    Alignment: "Alignment",
    All: "All",
    AllCategories: "All categories",
    AllCertifications: "All certifications",
    AllConnectors: "All connectors",
    AllCourses: "All courses",
    AllCustomEntityTypes: "All custom list types",
    AllFieldTypes: "All field types",
    AllGroups: "All groups",
    AllowCopyingClipboard: "Allow copying to the clipboard",
    AllowDownloads: "Allow downloads",
    AllowSelectionMultipleValues: "Allow selection of multiple values",
    AllowTemporarySupportAccess: "Allow eOne support to grant temporary access",
    AllowUserChangeTones: "Allow user to change tones",
    AllPeriods: "All periods",
    AllStatuses: "All statuses",
    AllUsers: "All users",
    AllowMultipleFiles: "Allow multiple files",
    AllowMultipleValues: "Allow multiple values to be selected",
    AllowTokenAsQueryParameter: "Allow token to be sent as a query parameter",
    AllowUserTokensForEndpoint: "Allow user tokens to access this endpoint",
    AllowedAuthenticatorApps: "Allowed authenticator apps",
    AllowedDomains: "Allowed domains",
    AllowedFileTypes: "Allowed file types",
    AlternateRows: "Alternate rows",
    AlternateRowStyle: "Alternate row style",
    AltText: "Alt text",
    AltTextField: "Alt text field",
    AmountDue: "Amount due",
    Api: "API",
    ApiEndpoint: "API endpoint",
    ApiEndpoints: "API endpoints",
    ApiName: "API name",
    ApiUser: "API user",
    ApiUsers: "API users",
    App: "App",
    Appearance: "Appearance",
    Applied: "Applied to",
    AppliedInvoices: "Applied invoices",
    ApplyMaxRecords: "Apply max records",
    ApplyParametersStages: "Apply parameters in stages",
    AppRegistration: "App registration",
    AppRegistrationDetails: "App registration details",
    AppRegistrations: "App registrations",
    AppSettings: "App settings",
    AppStore: "App store",
    AppSubmissions: "App submissions",
    AppType: "App type",
    AppendListItems: "Append to existing list items",
    Application: "Application",
    AppliesTo: "Applies to",
    Apply: "Apply",
    Apps: "Apps",
    AsRequestHeader: "As request header",
    AsRequestParameter: "As request url parameter",
    Ascending: "Ascending",
    AssignAll: "Assign all",
    AssignUser: "Assign user",
    AssignedTo: "Assigned to user",
    AssignUserTeam: "Assign user/team",
    AttachedTo: "Attached to",
    Attachment: "Attachment",
    AttachmentFileFormat: "Attachment file format",
    AttachmentSettings: "Attachment settings",
    AttachmentType: "Attachment type",
    Attachments: "Attachments",
    AuthenticatingWithConnector: "Authenticating with {0}",
    Authentication: "Authentication",
    AuthenticationMethod: "Authentication method",
    AuthenticationMethodBasic: "Basic authentication",
    AuthenticationMethodBearerToken: "Bearer token",
    AuthenticationMethodExchangeToken: "Exchange token",
    AuthenticationMethodNone: "None",
    AuthenticationMethodOAuth1: "OAuth 1.0",
    AuthenticationMethodOAuth2: "OAuth 2.0",
    AuthenticationType: "Authentication type",
    Author: "Author",
    Authorization: "Authorization",
    AuthorizationCode: "Authorization code",
    AuthorizationUrl: "Authorization URL",
    Authorize: "Authorize",
    AutofillRows: "Autofill rows",
    AutofillRowsChartAccounts: "Autofill rows from your chart of accounts",
    AutoMapFields: "Auto-map fields",
    AutomaticallyAddMapParameters: "Automatically add and map parameters",
    Availability: "Availability",
    Available: "Available",
    AvailableSortFields: "Available sort fields",
    Back: "Back",
    Backup: "Backup",
    BackgroundColor: "Background color",
    BackgroundType: "Background type",
    BackVersions: "Back to versions",
    Badges: "Badges",
    BarcodeType: "Barcode type",
    BaseColor: "Base color",
    BaseEntity: "Base list",
    BaseEntityFilters: "Base list restrictions",
    BaseEntityVariables: "Base list variables",
    BaseField: "Base field",
    BasePrice: "Base price",
    BaseRestrictions: "Base restrictions",
    BaseTimeUnit: "Base time unit",
    BaseUrl: "Base URL",
    BaseUrlForActions: "Base URL for open website actions",
    BaseUrlFrom: "Base URL from",
    BaseVariables: "Base variables",
    BatchSize: "Batch size",
    Beautify: "Beautify",
    BilledAnnually: "{0} billed annually",
    BilledMonthly: "billed monthly",
    BilledOnUsage: "Billed on usage",
    Billing: "Billing",
    BillingAddress: "Billing address",
    BillingPeriod: "Billing period",
    BillingPortalUnavailable: "Billing portal unavailable",
    BlankValue: "(blank)",
    BlockedDomains: "Blocked domains",
    BlockType: "Block type",
    Board: "Board",
    BoardSettings: "Board settings",
    Body: "Body",
    BodyForm: "Body form",
    BodyStyle: "Body style",
    BodyType: "Body type",
    Bold: "Bold",
    BorderColor: "Border color",
    BorderRadius: "Border radius",
    Borders: "Borders",
    Bottom: "Bottom",
    BottomBorder: "Bottom border",
    BrowseYourConnectors: "Browse your connectors",
    BucketType: "Bucket type",
    BucketTypeMonth: "Month",
    BucketTypeQuarter: "Quarter",
    BucketTypeYear: "Year",
    Build: "Build",
    BuildFormNamed: "Build \"{0}\" form",
    Building: "Building",
    BuildingForm: "Building form",
    BulletType: "Bullet type",
    Button: "Button",
    CalculatedParameters: "Calculated parameters",
    CannotAddClientMapping: "Cannot add client mapping",
    CannotAddMapping: "Cannot add mapping",
    CantAdd: "Can't add",
    CantDeleteField: "Can't delete field",
    CantDeleteVariable: "Can't delete variable",
    CantRevoke: "Can't revoke",
    CantSave: "Can't save",
    Capabilities: "Capabilities",
    Capability: "Capability",
    Card: "Card",
    CardNumber: "Card number",
    CardLayout: "Card layout",
    Cards: "Cards",
    CardSettings: "Card settings",
    CardholderName: "Cardholder name",
    Caching: "Caching",
    CalculatedField: "Calculated field",
    CalculatedFields: "Calculated fields",
    CalculatedVariable: "Calculated variable",
    CalculatedVariables: "Calculated variables",
    Calculation: "Calculation",
    Calculations: "Calculations",
    Calendar: "Calendar",
    Cancel: "Cancel",
    CancelButton: "Cancel button",
    CancelButtonLabel: "Cancel button label",
    CancellationFailed: "Cancellation failed",
    CancelSubscription: "Cancel subscription",
    Cancelled: "Cancelled",
    Cancelling: "Cancelling",
    CantDelete: "Can't delete",
    CardEndingIn: "Card ending in",
    CardFields: "Card fields",
    CardTitle: "Card title",
    Catalog: "Catalog",
    Category: "Category",
    CategoryField: "Category field",
    Center: "Center",
    Certification: "Certification",
    Certifications: "Certifications",
    Change: "Change",
    ChangeAdmin: "Change administrator",
    ChangeAiModel: "Change AI model",
    ChangeEndpoint: "Change endpoint",
    ChangeOwner: "Change owner",
    ChangePassword: "Change password",
    ChangePlan: "Change plan",
    ChangeProfilePicture: "Change profile picture",
    ChangesAreProrated: "Changes are prorated",
    ChangeSubscription: "Change subscription",
    ChangeVsToday: "Change vs today",
    ChangingAiModel: "Changing AI model",
    CharactersToDisplay: "Characters to display",
    Chart: "Chart",
    ChartExportFilename: "chart.png",
    ChartSettings: "Chart settings",
    ChartType: "Chart type",
    Chat: "Chat",
    ChatProjects: "Chat projects",
    CheckoutFailed: "Checkout failed",
    CheckoutUnavailable: "Checkout unavailable",
    CheckStatus: "Check status",
    ChildCompany: "Child company",
    ChildCompanyPluralPrompt: "Child company plural prompt",
    ChildCompanyPrompt: "Child company prompt",
    ChildFields: "Child fields",
    Children: "Children",
    ChoosePlan: "Choose plan",
    ChunkField: "Chunk field",
    ChunkStrategy: "Chunk strategy",
    City: "City",
    Clear: "Clear",
    ClearAll: "Clear all",
    ClearFilters: "Clear all filters",
    ClearGroups: "Clear all groups",
    ClearValue: "Clear value",
    Cli: "CLI",
    ClickAddPrompt: "Click to add a prompt",
    ClickAddResource: "Click to add a resource",
    ClickAddTool: "Click to add a tool",
    ClickEditFilter: "Click to edit filters",
    Client: "Client",
    ClientCredentials: "Client credentials",
    ClientId: "Client ID",
    ClientInstructions: "Client instructions",
    ClientInstructionSettings: "Client instruction settings",
    ClientMappings: "Client mappings",
    ClientMappingSettings: "Client mapping settings",
    ClientName: "Client name",
    ClientSecret: "Client secret",
    ClientSecrets: "Client secrets",
    ClientType: "Client type",
    Clone: "Clone",
    CloneStyle: "Clone style",
    Close: "Close",
    CloseAllOtherTabs: "Close all other tabs",
    CloseMenu: "Close menu",
    CloseSelected: "Close selected",
    CloseTab: "Close tab",
    CloseTabsToLeft: "Close tabs to the left",
    CloseTabsToRight: "Close tabs to the right",
    CloseWithoutSaving: "Close without saving",
    Code: "Code",
    CodeGenerator: "Code generator",
    CodeMode: "Code mode",
    CodeModeOnly: "Code mode only",
    CodeToolName: "Code tool name",
    Collapse: "Collapse",
    CollapseAll: "Collapse all",
    CollapseCard: "Collapse card",
    CollapseColumn: "Collapse column",
    Color: "Color",
    Color2: "To color",
    ColorCoding: "Color coding",
    ColorCodingDetails: "Color coding details",
    ColorField: "Color field",
    ColorGradients: "Color gradients",
    ColorMode: "Color mode",
    ColorModeColorful: "Colorful",
    ColorModeGradient: "Gradient",
    ColorModeMonochrome: "Monochrome",
    ColorPaletteDetails: "Color palette details",
    ColorPalettes: "Color palettes",
    ColorPaletteSettings: "Color palette settings",
    Colors: "Colors",
    Column: "Column",
    ColumnField: "Column field",
    ColumnNumber: "Column {0}",
    ColumnSpan: "Column span",
    ColumnSummaryMethod: "Column summary method",
    ColumnToDuplicate: "Column to duplicate",
    Columns: "Columns",
    CompactList: "Compact list",
    Companies: "Companies",
    Company: "Company",
    CompanyIdFieldPath: "Company ID field path",
    CompanyName: "Company name",
    CompanyPlaceholderId: "{0} ID",
    CompanyPlaceholderName: "{0} name",
    CompanyPluralPrompt: "Company plural prompt",
    CompanyPrompt: "Company prompt",
    CompanySettings: "Company settings",
    Compare: "Compare",
    CompareCurrentVersion: "Compare with current version",
    CompareDependencies: "Compare dependencies",
    CompareEntityPlaceholder: "Compare {0}",
    CompareField: "Compare from field",
    CompareField2: "Compare to field",
    CompareFields: "Compare fields",
    CompareFromEntity: "Compare from list",
    CompareFromEntityRestrictions: "Compare from list restrictions",
    CompareRestrictions: "Compare from restrictions",
    CompareRestrictions2: "Compare to restrictions",
    CompareToConnector: "Compare to connector",
    CompareToEntity: "Compare to list",
    CompareToEntityRestrictions: "Compare to list restrictions",
    Comparison: "Comparison",
    ComparisonFields: "Comparison fields",
    ComparisonMethodDifferences: "Show differences",
    ComparisonMethodSimilarities: "Show similarities",
    ComparisonType: "Comparison type",
    Completed: "Completed",
    CompletedWithErrors: "Completed with errors",
    Components: "Components",
    Conditions: "Conditions",
    Confidential: "Confidential",
    Configure: "Configure",
    ConfigureYourMcpServer: "Configure your MCP server",
    Confirm: "Confirm",
    ConfirmAddOns: "Confirm add-ons",
    ConfirmBillingChange: "Confirm billing change",
    ConfirmButton: "Confirm button",
    ConfirmChange: "Confirm change",
    ConfirmDelete: "Confirm delete",
    Confirmation: "Confirmation",
    ConfirmationPrompt: "Confirmation prompt",
    ConfirmPlanChange: "Confirm plan change",
    ConfirmSubscription: "Confirm subscription",
    ConfirmSubscriptionChange: "Confirm subscription change",
    ConjunctiveAnd: "and",
    ConjunctiveOr: "or",
    Connect: "Connect",
    ConnectADataSource: "Connect a data source",
    ConnectAnAiProviderAndDataSource: "Connect an AI provider and a data source",
    ConnectAndSave: "Save and connect",
    ConnectConnector: "Connect {0}",
    ConnectToConnector: "Connect to {0}",
    Connected: "Connected",
    ConnectedToConnector: "Connected to {0}",
    Connection: "Connection",
    ConnectionType: "Connection type",
    Connector: "Connector",
    ConnectorAction: "Connector action",
    ConnectorActionField: "Connector action field",
    ConnectorActions: "Field type actions",
    ConnectorConnected: "{0} connected",
    ConnectorDetails: "Connector details",
    ConnectorLogo: "Connector logo",
    ConnectorPermissions: "Connector permissions",
    ConnectorRoles: "connector roles",
    ConnectorSelected: "{0} selected",
    ConnectorSelectedClickAgainToRemove: "{0} selected - click again to remove",
    ConnectorSettings: "Connector settings",
    ConnectorType: "Connector type",
    ConnectorValues: "Connector values",
    ConnectorVariables: "Connector variables",
    Connectors: "Connectors",
    Constant: "Constant",
    Constants: "Constants",
    ConstantValue: "Constant value",
    ContactDetails: "Contact details",
    Containers: "Containers",
    Content: "Content",
    Contents: "Contents",
    Continue: "Continue",
    ContinueBrowsing: "Continue browsing",
    ContinueToBillingPortal: "Continue to billing portal",
    Copy: "Copy",
    Copy2: "Copy from",
    CopyActionField: "Copy from an action field",
    CopyAnotherDocument: "Copy from another document",
    CopyAsCurl: "Copy as cURL",
    CopyCalculatedFields: "Copy calculated fields to the new list",
    CopyColumns: "Copy columns",
    CopyColumnsAnotherReport: "Copy columns from another report",
    CopyConnectors: "Copy connectors",
    CopyFooter: "Copy footer",
    CopyFormSnippet: "Copy your form snippet",
    CopyHeader: "Copy header",
    CopyListField: "Copy from a list field",
    CopyListItems: "Copy list items",
    CopyMcpServerUrl: "Copy your MCP server URL",
    CopyMembers: "Copy members",
    CopyProperties: "Copy properties",
    CopyPropertiesAnotherDocument: "Copy properties from another document",
    CopyQueriesAnotherDocument: "Copy queries from another document",
    CopyQuery: "Copy query",
    CopyReportingTree: "Copy reporting tree",
    CopyReportingTreeAnotherReport: "Copy the reporting tree from another report",
    CopyRoles: "Copy roles",
    CopyRow: "Copy row",
    CopyRows: "Copy rows",
    CopyRowsAnotherReport: "Copy rows from another report",
    CopySecurity: "Copy security",
    CopySharing: "Copy sharing",
    CopyStyles: "Copy styles",
    CopyStylesFromAnotherDocument: "Copy styles from another document",
    CopyTeams: "Copy teams",
    CopyToClipboard: "Copy to clipboard",
    CopyUser: "Copy from another user",
    CopyValue: "Copy value",
    CopyVariable: "Copy from a variable",
    CopyVariable2: "Copy from variable",
    CopyingData: "Copying data",
    CountOfCountEnabled: "{0} of {1} enabled",
    Country: "Country",
    CouponCode: "Coupon code",
    Course: "Course",
    Courses: "Courses",
    CreateAnMcpServer: "Create an MCP server",
    CreateAPrompt: "Create a prompt",
    CreateColumnsBasedField: "Create columns based on field",
    CreateGetDataToolFor: "Create get-data tool for {0}",
    Created: "Created",
    CreatedBy: "Created by",
    CreateDraftInsteadOfSending: "Create draft instead of sending",
    CreateMcpServer: "Create MCP server",
    CreateMcpServerNamed: "Create MCP server {0}",
    CreatePathIfNotExists: "Create the path if it doesn't exist",
    CreateRecord: "Create record",
    CreateRowsBasedField: "Create rows based on field",
    CreateSelectedTools: "Create the selected tools",
    CreateSelectedToolsAndPrompts: "Create the selected tools and prompts",
    CreateVersion: "Create version",
    CreateVisualforcePage: "Create Visualforce page",
    CreateWidget: "Create widget",
    CreatedDate: "Created date",
    CreatingGetDataTool: "Creating get-data tool",
    CreatingPrompts: "Creating prompts",
    CreatingServer: "Creating server",
    CreatingTools: "Creating tools",
    Credentials: "Credentials",
    CredentialSharing: "Credential sharing",
    CreditCard: "Credit card",
    CreditCardExpired: "Credit card expired",
    CropImage: "Crop image",
    Csv: "CSV",
    Curl: "cURL",
    Currency: "Currency",
    CurrentPlan: "Current plan",
    CurrentProcess: "Current process",
    Cursor: "Cursor",
    Custom: "Custom",
    CustomActions: "Custom actions",
    CustomDateFilters: "Custom date filters",
    CustomDateFormat: "Custom date format",
    CustomEntities: "Custom lists",
    CustomEntities2: "Custom entities",
    Customers: "Customers",
    CustomListDetails: "Custom list details",
    CustomResponses: "Custom responses",
    CustomizationPermissions: "Customization permissions",
    Customize: "Customize",
    DarkMode: "Dark mode",
    Dashboard: "Dashboard",
    Dashboards: "Dashboards",
    DataEndpoints: "Data endpoints",
    DataLakeDestination: "Data lake destination",
    DataRequest: "Data request",
    DataSource: "Data source",
    Data: "Data",
    Database: "Database",
    DateField: "Date field",
    DateFormat: "Date format",
    DateLevels: "Date levels",
    DateRange: "Date range",
    DateRangeMode: "Date range mode",
    DateRangeModePredefined: "Auto bucket",
    DateRangeModeManual: "Manual ranges",
    DateRangeLabel: "Label",
    DateRangeStart: "Start date",
    DateRangeEnd: "End date",
    DateRangeAddRange: "Add range",
    DateSummaryMethod: "Date summary method",
    DateTimeAdjustmentMethod: "Date/time adjustment method",
    DateTimeOptions: "Date/time options",
    DateType: "Date type",
    DateValue: "Date value",
    DateValues: "Date values",
    Day: "Day",
    DayName: "Day (name)",
    DayOrdinal: "Day (ordinal)",
    Days: "Days",
    DaysOfTheWeek: "Days of the week",
    DaysOfTheMonth: "Days of the month",
    DayType: "Day type",
    DayWeek: "Day of week",
    Deactivate: "Deactivate",
    DeactivateUser: "Deactivate user",
    DeactivateWidget: "Unpublish widget",
    DecimalPlaces: "Decimal places",
    Decimals: "Decimals",
    Default: "Default",
    DefaultColumns: "Default columns",
    DefaultEntity: "Default list",
    DefaultFields: "Default fields",
    DefaultFont: "Default font",
    DefaultFontSize: "Default font size",
    DefaultPalette: "Default palette",
    DefaultPath: "Default path",
    DefaultScript: "Default script",
    DefaultTheme: "Default theme",
    DefaultValue: "Default value",
    DefaultValueType: "Default value type",
    DefaultValues: "Default values",
    DefaultView: "Default view",
    Definition: "Definition",
    Delete: "Delete",
    DeleteBranch: "Delete branch",
    DeleteColumn: "Delete column",
    Deleted: "Deleted",
    DeleteExtension: "Delete extension",
    DeleteFailed: "Delete failed",
    DeleteFavorite: "Delete favorite",
    DeleteField: "Delete field",
    DeleteLoop: "Delete loop",
    DeleteParameter: "Delete parameter",
    DeleteProcess: "Delete process",
    DeleteTask: "Delete task",
    DeleteVariable: "Delete variable",
    DeleteVisualforcePage: "Delete Visualforce page",
    DeletedConnectors: "Deleted connectors",
    Deliver: "Deliver to",
    Delivery: "Delivery",
    DeliveryMode: "Delivery mode",
    DeliveryModeAlwaysOn: "Always on",
    DeliveryModeOff: "Off",
    DeliveryModeOnDemand: "On demand",
    Dependencies: "Dependencies",
    Descending: "Descending",
    Description: "Description",
    Destination: "Destination",
    DestinationConnector: "Destination connector",
    Detail: "Detail",
    DetailDisplayTypeBelow: "Below the record",
    DetailDisplayTypeDrillDown: "Drill down to a new page",
    DetailDisplayTypeDrillDownFromField: "Drill down from field link",
    DetailDisplayTypeNone: "Do not display",
    DetailDisplayTypeRight: "In the sidebar",
    DetailFields: "Detail fields",
    Details2: "details",
    DetailSettings: "Detail settings",
    DetailTypeGroup: "Group",
    DetailTypeIFrame: "Iframe",
    DetailTypeImage: "Image",
    DetailTypeList: "List",
    DetailTypeShipping: "Shipping details",
    DetailTypeSingleton: "Single record",
    DetailTypeSummary: "Summary",
    DetailTypeFile: "File",
    Details: "Details",
    Developer: "Developer",
    DeveloperPermissions: "Developer permissions",
    Developers: "Developers",
    Difficulty: "Difficulty",
    Dimension: "Dimension",
    Dimensions: "Dimensions",
    DimensionValues: "Dimension values",
    Direction: "Direction",
    Disabled: "Disabled",
    DisabledConnectors: "Disabled connectors",
    DisableFiltering: "Disable filtering",
    DisableGrouping: "Disable grouping",
    DisableNotifications: "Disable notifications",
    DisableSorting: "Disable sorting",
    DisableTotals: "Disable totals",
    Discount: "Discount",
    Dismiss: "Dismiss",
    Display: "Display",
    DisplayAiChatInterface: "Display an AI chat interface",
    DisplayAsNegative: "Display as negative",
    DisplayAsNegativeBasedOnField: "Display as negative based on another field",
    DisplayField: "Display field",
    DisplayFields: "Display fields",
    DisplayFile: "Display a file",
    DisplayForAllCompanies: "Display for all companies",
    DisplayIframe: "Display an iFrame",
    DisplayImage: "Display an image",
    DisplayMethod: "Display method",
    DisplayRelatedList: "Display a related list",
    DisplayShippingInformation: "Display shipping information",
    DisplaySingleRecord: "Display a single record",
    DisplaySummaryRelatedList: "Display a summary of a related list",
    DisplayTextUnderBarcode: "Display text under barcode",
    DisplayTimeUnit: "Display time unit",
    DisplayType: "Display type",
    DisplayValue: "Display value",
    DisplayValuesInList: "Display available values in a drop down list",
    Divider: "Divider",
    DocumentProperties: "Document properties",
    Documents: "Documents",
    DoNotAddSecurity: "Do not add security",
    DoNotCopy: "Do not copy",
    DoNotDefault: "Do not default",
    DoNotDisplayWidget: "Do not display this widget",
    DoNotImport: "Do not import",
    DoNotSet: "Do not set",
    DoNotUrlEncode: "Do not URL encode",
    Domain: "Domain",
    DoneEditing: "Done editing",
    Done: "Done",
    DontSave: "Don't save",
    Downgrade: "Downgrade",
    Download: "Download",
    DownloadAll: "Download all",
    DownloadFailed: "Download failed",
    Downloads: "Downloads",
    Due: "Due",
    DueToday: "Due today",
    Duplicate: "Duplicate",
    DuplicateAction: "Duplicate action",
    DuplicateAdaptiveCardTemplate: "Duplicate adaptive card template",
    DuplicateAiToneModifier: "Duplicate AI tone modifier",
    DuplicateMcpServer: "Duplicate MCP server",
    DuplicateWidget: "Duplicate widget",
    DuplicateAttachment: "Duplicate attachment",
    DuplicateCalculatedField: "Duplicate calculated field",
    DuplicateColumn: "Duplicate column",
    DuplicateConnector: "Duplicate connector",
    DuplicateDetail: "Duplicate detail",
    DuplicateEntity: "Duplicate list",
    DuplicateExcelTemplate: "Duplicate Excel template",
    DuplicateFavorite: "Duplicate favorite",
    DuplicateFavoritePrompt: "Duplicate favorite prompt",
    DuplicateFields: "Duplicate fields",
    DuplicatePdfTemplate: "Duplicate PDF template",
    DuplicatePrompt: "Duplicate prompt",
    DuplicateRedactionMethod: "Duplicate redaction method",
    DuplicateReport: "Duplicate report",
    DuplicateRole: "Duplicate role",
    DuplicateRow: "Duplicate row",
    DuplicateTeam: "Duplicate team",
    DuplicateTool: "Duplicate tool",
    Duration: "Duration",
    Dynamic: "Dynamic",
    DynamicRow: "Dynamic row",
    Each: "each",
    EachUserNeedsCredentials: "Require each Popdock user to enter their own credentials for this connector",
    Edit: "Edit",
    EditAction: "Edit action",
    EditActionField: "Edit action field",
    EditAddOns: "Edit add-ons",
    EditAllFields: "Edit all fields",
    EditBaseUrl: "Edit base URL",
    EditBillingAddress: "Edit billing address",
    EditCalculatedColumn: "Edit calculated column",
    EditCalculatedField: "Edit calculated field",
    EditCalculatedRow: "Edit calculated row",
    EditCalculation: "Edit calculation",
    EditColorCoding: "Edit color coding",
    EditColumn: "Edit column",
    EditConnector: "Edit connector",
    EditConnectorAction: "Edit connector action",
    EditConnectorSettings: "Edit connector settings",
    EditCustomAction: "Edit custom action",
    EditCustomEntity: "Edit custom list",
    EditDashboard: "Edit dashboard",
    EditDecimalPlaces: "Edit decimal places",
    EditDetail: "Edit detail",
    EditDynamicRow: "Edit dynamic row",
    EditEmbeddedApp: "Edit embedded app",
    EditEmbeddedApps: "Edit embedded apps",
    EditEndpoint: "Edit endpoint",
    EditEntity: "Edit list",
    EditEntityAction: "Edit list action",
    EditExchangeTokenUrl: "Edit exchange token URL",
    EditExportAction: "Edit export action",
    EditFavorite: "Edit favorite",
    EditField: "Edit field",
    EditFields: "Edit fields",
    EditFileName: "Edit file name",
    EditFilter: "Edit filter",
    EditFirewall: "Edit firewall",
    EditFiscalYear: "Edit fiscal year",
    EditFlow: "Edit flow",
    EditGroup: "Edit group",
    EditHomePage: "Edit home page",
    EditHomePageItem: "Edit home page item",
    EditIframeUrl: "Edit Iframe URL",
    EditJob: "Edit job",
    EditJoin: "Edit join",
    EditLabel: "Edit label",
    EditListItem: "Edit list item",
    EditListItems: "Edit list items",
    EditLookup: "Edit lookup",
    EditMergeList: "Edit merge list",
    EditOpenUrlAction: "Edit open website action",
    EditParameter: "Edit parameter",
    EditParameters: "Edit parameters",
    EditProfile: "Edit profile",
    EditRelationship: "Edit relationship",
    EditRestriction: "Edit restriction",
    EditRole: "Edit role",
    EditRow: "Edit row",
    EditScript: "Edit script",
    EditSections: "Edit sections",
    EditSendApiRequestAction: "Edit send API request action",
    EditSettings: "Edit settings",
    EditSidebar: "Edit sidebar",
    EditSort: "Edit sort",
    EditStyle: "Edit style",
    EditSummaryColumn: "Edit summary column",
    EditSummaryMethod: "Edit summary method",
    EditSummaryRow: "Edit summary row",
    EditTable: "Edit table",
    EditTag: "Edit tag",
    EditTeam: "Edit team",
    EditTheme: "Edit theme",
    EditUser: "Edit user",
    EditVariable: "Edit variable",
    EditVirtualNetwork: "Edit virtual network",
    EditWidget: "Edit widget",
    EditWidgetFirewall: "Edit widget firewall",
    EditWorksheetName: "Edit worksheet name",
    EditZipFileName: "Edit ZIP file name",
    Elements: "Elements",
    EffectivePath: "Effective path",
    Email: "Email",
    EmailAddress: "Email address",
    EmailAddresses: "Email addresses",
    EmailBuilder: "Email builder",
    EmailConnector: "Email connector",
    EmailScheduled: "Email scheduled",
    EmailSignatures: "Email signatures",
    EmailTemplates: "Email templates",
    EmbedCodes: "Embed codes",
    EmbedFormReady: "Embed form ready",
    EmbedSnippetReady: "Embed snippet ready",
    EmbeddedData: "Embedded data",
    EmbeddedForm: "Embedded form",
    EmbedLocation: "Embed location",
    EmbeddedWidgetsToScaffold: "Embedded widgets to scaffold",
    EnableCodeMode: "Enable code mode",
    EnableFileUploads: "Enable file uploads",
    Enabled: "Enabled",
    EnablePkce: "Enable PKCE",
    EndColor: "End color",
    EndDate: "End date",
    EndDateType: "End date type",
    EndIp: "End IP",
    EndMonth: "End month",
    EndpointDetails: "Endpoint details",
    EndpointSettings: "Endpoint settings",
    EndYear: "End year",
    Endpoint: "Endpoint",
    EndpointFrom: "Endpoint from",
    Endpoints: "Endpoints",
    EnterConnectorName: "Enter connector name",
    EnterHtml: "Enter HTML",
    EnterNewTag: "Enter new tag",
    EnterParameterValues: "Enter parameter values",
    EnterValue: "Enter value",
    EnterValues: "Enter values",
    Entities: "Lists",
    Entity: "List",
    Entity2: "Entity",
    EntityAction: "List action",
    EntityActions: "List actions",
    EntityField: "List field",
    EntityFields: "List fields",
    EntityName: "List name",
    EntitySettings: "List settings",
    Environment: "Environment",
    EnvironmentParameter: "Environment parameter",
    EnvironmentParameters: "Environment parameters",
    EnvironmentVersion: "Environment version",
    Error: "Error",
    ErrorChangingModel: "Error changing model",
    ErrorCode: "Error code",
    ErrorConnecting: "Error connecting",
    ErrorDescription: "Error description",
    ErrorDownloading: "Error downloading",
    ErrorHandling: "Error handling",
    ErrorLoadingEnvironmentParameters: "Error loading environment parameters",
    ErrorMessage: "Error message",
    ErrorPublishing: "Error publishing",
    ErrorRunningAction: "Error running action",
    Errors: "Errors",
    ErrorValidating: "Error validating",
    Event: "Event",
    Every: "Every",
    EveryDay: "Every day",
    Everyone: "Everyone",
    Excel: "Excel",
    ExcelAddin: "Excel add-in",
    ExcelDocuments: "Excel Documents",
    ExcelTemplates: "Excel templates",
    ExchangeToken: "Exchange token",
    ExchangeTokenParameters: "Exchange token parameters",
    ExchangeTokenUrl: "Exchange token URL",
    Executions: "Executions",
    Expand: "Expand",
    ExpandAll: "Expand all",
    ExpandCard: "Expand card",
    ExpandColumn: "Expand column",
    Expired: "Expired",
    Expires: "Expires",
    ExpiresIn: "Expires in",
    ExpiringSoon: "Expiring soon",
    Expiry: "Expiry",
    ExpiresInDays: "Expires in (days)",
    Export: "Export",
    ExportAction: "Export action",
    ExportActionNames: "Export action names",
    ExportActions: "Export actions",
    ExportAiToneModifier: "Export AI tone modifier",
    ExportConnector: "Export connector",
    ExportDetail: "Export detail",
    ExportEndpoint: "Export endpoint",
    ExportEntityNames: "Export list names",
    ExportFailed: "Export failed",
    ExportFavorite: "Export favorite",
    ExportFavorites: "Export favorites",
    ExportField: "Export field",
    ExportFieldNames: "Export field names",
    ExportFile: "Export file",
    ExportFileType: "Export type",
    ExportFiscalYear: "Export fiscal year",
    ExportGroups: "Export groups",
    ExportIncomplete: "Export incomplete",
    ExportLookup: "Export lookup",
    ExportMcpClient: "Export MCP client",
    ExportMcpPrompt: "Export MCP prompt",
    ExportMcpServer: "Export MCP server",
    ExportMcpTool: "Export MCP tool",
    ExportMcpWidget: "Export MCP widget",
    ExportMessagingTemplate: "Export messaging template",
    ExportPermissions: "Export permissions",
    ExportPostmanCollection: "Export to Postman collection",
    ExportRedactionMethod: "Export redaction method",
    ExportTo: "Export to",
    ExportToMultipleFiles: "Export to multiple files",
    ExportWidget: "Export widget",
    ExportWorkflow: "Export workflow",
    Expression: "Expression",
    Extender: "Extender",
    Extension: "Extension",
    ExtensionSettings: "Extension settings",
    ExtensionVersion: "Extension version",
    ExternalUser: "External user",
    ExternalUserDetails: "External user details",
    ExternalUsers: "External users",
    Facebook: "Facebook",
    Failed: "Failed",
    FailedConnectors: "Failed connectors",
    FailedIntegration: "Your integration failed to run",
    Failure: "Failure",
    Favorite: "Favorite",
    FavoriteName: "Favorite name",
    FavoriteOptions: "Favorite options",
    FavoritePrompts: "Favorite prompts",
    FavoriteSettings: "Favorite settings",
    FavoriteSummary: "Favorite summary",
    Favorites: "Favorites",
    Field: "Field",
    FieldFromParentList: "Field from parent list",
    FieldLanguage: "Field language",
    FieldMapping: "Field mapping",
    FieldMissing: "(Field missing)",
    FieldName: "Field name",
    FieldPath: "Field path",
    FieldsAdd: "Fields to add",
    FieldSettings: "Field settings",
    FieldsRemove: "Fields to remove",
    FieldSummarize: "Field to summarize",
    FieldToCopy: "Field to copy",
    FieldType: "Field type",
    FieldValue: "Field value",
    Fields: "Fields",
    File: "File",
    FileField: "File field",
    FileExtension: "File extension",
    FileFormat: "File format",
    FilePath: "File path",
    FileSplits: "File splits",
    FileUpload: "File Upload",
    Filename: "File name",
    FilenameField: "File name field",
    Files: "Files",
    Filter: "Filter",
    FilterField: "Filter field",
    FilterOnly: "Filter only",
    FilterRow: "Filter row",
    FilterType: "Filter type",
    FilterValue: "Filter value",
    FilterVariable: "Filter variable",
    FilterVariables: "Filter variables",
    Filters: "Filters",
    FindByConnector: "Find by connector",
    FindByTag: "Find by tag",
    FindInResults: "Find in results",
    Finish: "Finish",
    FinishSettingUpPopdock: "Finish setting up Popdock",
    Finished: "Finished",
    Firewall: "Firewall",
    Firewalls: "Firewalls",
    First: "First",
    FirstDayOfWeek: "First day of week",
    FirstEmailScheduled: "First email scheduled",
    FirstGetDataTool: "First get-data tool",
    FirstName: "First name",
    FirstResourceId: "First resource ID",
    FirstSummaryScheduled: "First summary scheduled",
    FiscalPeriod: "Fiscal period",
    FiscalPeriods: "Fiscal periods",
    FiscalYear: "Fiscal year",
    FiscalYearDetails: "Fiscal year details",
    FiscalYears: "Fiscal years",
    FitMethod: "Fit method",
    Fix: "Fix",
    FixedRestrictions: "Fixed restrictions",
    FixUploadDatabase: "Fix database upload",
    FixUploadTable: "Fix table upload",
    Flow: "Flow",
    FlowCredentials: "Flow credentials",
    FlowField: "Flow field",
    FlowParameter: "Flow parameter",
    Flows: "Flows",
    Folder: "Folder",
    FollowLinkedIn: "Follow us on LinkedIn",
    FollowTwitter: "Follow us on Twitter",
    Font: "Font",
    FontColor: "Font color",
    FontSize: "Font size",
    Footer: "Footer",
    Form: "Form",
    FormReady: "Form ready",
    FormReadyToEmbed: "Form ready to embed",
    FormatScript: "Format script",
    FormFieldType: "Form field type",
    FormFields: "Form fields",
    FormName: "Form name",
    FormSettings: "Form settings",
    Format: "Format",
    Forms: "Forms",
    Formula: "Formula",
    FormWidgets: "Form widgets",
    Fourth: "Fourth",
    FrequentlyUsed: "Frequently used",
    FrequentlyUsedFavorites: "Frequently used favorites",
    From: "From",
    FromCompany: "From company",
    FromDate: "From {0}",
    FromEntity: "From list",
    FromField: "From field",
    FromResponseBody: "From response body",
    FromResponseHeader: "From response header",
    FromTable: "From table",
    FromValue: "From value",
    FromValueType: "From value type",
    Fulfillment: "Fulfillment",
    Function: "Function",
    Functions: "Functions",
    Gateway: "Gateway",
    GatewayReference: "Gateway reference",
    GatewayVersion: "Gateway version",
    Generate: "Generate",
    GenerateCode: "Generate code",
    GenerateColumns: "Generate columns",
    GenerateColumnsBasedField: "Generate columns based on a field",
    GenerateFilterColumns: "Generate filter columns",
    GenerateFiscalPeriods: "Generate fiscal periods",
    GenerateRangeFiscalPeriods: "Generate a range of fiscal periods",
    GeneratingEmbed: "Generating your embed",
    GeneratingEmbeddedForm: "Generating your embedded form",
    GenerationMethod: "Generation method",
    GetData: "Get data",
    GetEntity: "Get {0}",
    GetStarted: "Let's get started",
    GettingThingsReady: "Getting things ready",
    GiveAccessToMigration: "Give them access to your migration",
    GiveAccessToNewAiSummary: "Give them access to your new AI summary",
    GiveAccessToNewConnector: "Give them access to your new connector",
    GiveAccessToNewConnectorNamed: "Give them access to your new {0} connector",
    GiveAccessToNewForm: "Give them access to your new form",
    GiveAccessToNewMcpServer: "Give them access to your new MCP server",
    GiveAccessToNewWidget: "Give them access to your new widget",
    GiveAccessToScheduledEmail: "Give them access to your scheduled email",
    GiveAccessToWhatYouBuilt: "Give them access to what you just built",
    GlobalVariable: "Global variable",
    GlobalVariables: "Global variables",
    Glossary: "Glossary",
    GlossaryItems: "Glossary items",
    GoBack: "Go back",
    GoBackHome: "Go back to the home page",
    GoBackToAction: "Go back to Action",
    GoBackToAppStore: "Go back to App store",
    GoBackToCompany: "Go back to Company",
    GoBackToConnector: "Go back to Connector",
    GoBackToConnectors: "Go back to Connectors",
    GoBackToDeveloper: "Go back to Developer",
    GoBackToEntity: "Go back to List",
    GoBackToHistory: "Go back to History",
    GoBackToProfile: "Go back to Profile",
    GoBackToSecurity: "Go back to Security",
    GoBackToTeam: "Go back to Team",
    GoBackToThePreviousPage: "Go back to the previous page",
    GoBackToUser: "Go back to User",
    GoBackToWidget: "Go back to Widget",
    GoConnector: "Go to your connector",
    GoMcpServer: "Go to your MCP server",
    GoMigrationConnector: "Go to your migration connector",
    GoPopdock: "Go to Popdock",
    Goal: "Goal",
    GradientValueField: "Gradient value field",
    Granularity: "Granularity",
    Graphical: "Graphical",
    GridColumnSizingFitToGrid: "Fit columns to the width of the grid",
    GridColumnSizingFixedColumn: "Column width is based on the field type",
    GridColumnSizingMethod: "Column sizing method",
    Group: "Group",
    GroupDetails: "Group details",
    GroupField: "Group by field",
    GroupFields: "Group fields",
    Grouping: "Grouping",
    GroupNumber: "Group number",
    Groups: "Groups",
    GroupSummaryMethod: "Group summary method",
    HasCustomScript: "Has custom script",
    HasMorePagesPath: "Has more pages path",
    HasMorePagesPathType: "Has more pages path type",
    Header: "Header",
    HeaderField: "Header field",
    HeaderLinkField: "Header link field",
    Headers: "Headers",
    HeadersFooters: "Headers and footers",
    HeaderStyle: "Header style",
    Height: "Height",
    Help: "Help",
    HexColor: "Hex color",
    Hidden: "Hidden",
    HiddenField: "Hidden field",
    HiddenFields: "Hidden fields",
    HiddenValues: "Hidden values",
    Hide: "Hide",
    HideColumns: "Hide columns",
    HideDetails: "Hide details",
    HideEmptyColumns: "Hide empty columns",
    HideEmptyRows: "Hide empty rows",
    HideFieldTypes: "Hide field types",
    HideFirstPage: "Hide on first page",
    HideGroupingContainer: "Hide grouping container",
    HideHelp: "Hide help",
    HideIndividualTools: "Hide individual tools",
    HideSearch: "Hide search",
    HideSettings: "Hide settings",
    History: "History",
    HistoryDetails: "History details",
    Home: "Home",
    Hours: "Hours",
    HtmlTable: "HTML table",
    Icons: "Icons",
    IFrame: "Iframe",
    Iframe: "iFrame",
    IFrameEmbedCode: "Iframe embed code",
    IFrameURL: "Iframe URL",
    ImageUrl: "Image URL",
    ImportAction: "Import action",
    ImportAction2: "Import an action",
    ImportAiToneModifier: "Import AI tone modifier",
    ImportAiToneModifier2: "Import an AI tone modifier",
    ImportApiEndpoint: "Import API endpoint",
    ImportATemplate: "Import a template",
    ImportAWidget: "Import a widget",
    ImportCalculatedField: "Import a calculated field",
    ImportCalculatedField2: "Import calculated field",
    ImportColor: "Import color",
    ImportColorPalettes: "Import color palettes",
    ImportColors: "Import colors",
    ImportComplete: "Import complete",
    ImportCustomList: "Import a custom list",
    ImportCustomList2: "Import custom list",
    ImportDetail: "Import a detail",
    ImportDetail2: "Import detail",
    ImportEndpoint: "Import an endpoint",
    ImportFavorite: "Import a favorite",
    ImportFavorite2: "Import favorite",
    ImportFile2: "Import from a file",
    ImportFiscalYear: "Import a fiscal year",
    ImportFiscalYear2: "Import fiscal year",
    ImportFormWidget: "Import a form widget",
    ImportFormWidget2: "Import form widget",
    ImportFromConnector: "Import from connector",
    ImportInProgress: "Import in progress",
    ImportListItemsConnector: "Import list items from the connector",
    ImportLookup: "Import a lookup",
    ImportLookup2: "Import lookup",
    ImportMcpClient: "Import an MCP client",
    ImportMcpClient2: "Import MCP client",
    ImportMcpServer: "Import an MCP server",
    ImportMcpServer2: "Import MCP server",
    ImportMessagingTemplate: "Import messaging template",
    ImportPrompt: "Import a prompt",
    ImportPrompt2: "Import prompt",
    ImportQueryBuilderList: "Import a Query Builder list",
    ImportQueryBuilderList2: "Import Query Builder list",
    ImportRedactionMethod: "Import a redaction method",
    ImportRedactionMethods: "Import redaction methods",
    ImportTheme: "Import a theme",
    ImportTool: "Import a tool",
    ImportTool2: "Import tool",
    ImportWidget: "Import widget",
    ImportWidgetGroup: "Import a widget group",
    ImportWidgetGroup2: "Import widget group",
    Included: "Included",
    InheritedFromTeam: "Inherited from team",
    InProgress: "In progress",
    Input: "Input",
    InsertParameter: "Insert parameter",
    InsertValue: "Insert value",
    InspectMigratedTables: "Inspect migrated tables",
    Instagram: "Instagram",
    InstallApps: "Install {0}",
    InstallingConnectors: "Installing connectors",
    InstallTo: "Install to",
    IntacctGroup: "Intacct group",
    IntacctUser: "Intacct user",
    IntegrationSettings: "Integration settings",
    InvitationSent: "Invitation sent",
    InviteYourTeamOptional: "Invite your team (optional)",
    Invoice: "Invoice #",
    Invoices: "Invoices",
    IPadApp: "iPad app",
    IpAddress: "IP address",
    IPhoneApp: "iPhone app",
    Icon: "Icon",
    Identifier: "Identifier",
    IdentifierType: "Identifier type",
    IfFileAlreadyExists: "If the file already exists",
    Image: "Image",
    ImageField: "Image field",
    Images: "Images",
    Import: "Import",
    ImportByEntity: "Import by list",
    ImportByFavorite: "Import by favorite",
    ImportByUser: "Import by user",
    ImportConnector: "Import connector",
    ImportFavorites: "Import favorites",
    ImportFile: "Import file",
    ImportFiscalYears: "Import fiscal years",
    ImportSmartListFavorites: "Import SmartList favorites",
    ImportSmartConnectFieldsFailed: "Failed to get error fields",
    Inactivate: "Inactivate",
    Inactive: "Inactive",
    InactiveUsers: "Inactive users",
    IncludeDiagnostics: "Include diagnostic information",
    IncludeEmptyRows: "Include empty rows",
    InheritFromAccount: "Inherit from account",
    InheritFromConnector: "Inherit from connector",
    IgnoreCommonWords: "Ignore common words",
    IgnoreWords: "Words to ignore",
    InputField: "Input field",
    Insert: "Insert",
    InsertField: "Insert field",
    InsertFile: "Insert file",
    InsertVariable: "Insert variable",
    InsightTypeArea: "Area",
    InsightTypeBar: "Bar",
    InsightTypeBubble: "Bubble",
    InsightTypeColumn: "Column",
    InsightTypeDoughnut: "Donut",
    InsightTypeFunnel: "Funnel",
    InsightTypeLine: "Line",
    InsightTypeNumber: "Number",
    InsightTypePie: "Pie",
    InsightTypeTreeMap: "Tree map",
    InsightTypeBumpChart: "Bump",
    InsightTypeWordCloud: "Word cloud",
    Insights: "Insights",
    Install: "Install",
    InstallThisApp: "Install this app",
    Installed: "Installed",
    Installing: "Installing",
    IntacctConnector: "Intacct connector",
    Integration: "Integration",
    Invalid: "Invalid",
    InvalidFile: "Invalid file",
    InvalidPartnerCode: "Invalid partner code",
    Invite: "Invite",
    InvitePartnerUser: "Invite partner user",
    InvitePlaceholderUser: "Invite {0} user",
    InviteSupportUsers: "Invite support users",
    InviteUsers: "Invite users",
    InvitedUsers: "Invited users",
    InvoiceAmount: "Amount",
    InvoiceDate: "Date",
    InvoiceDetails: "Invoice details",
    InvoiceNumber: "Invoice number",
    InvoiceStatus: "Status",
    IpAddresses: "IP addresses",
    Italic: "Italic",
    Item: "Item",
    ItemCategories: "Item categories",
    ItemCountField: "Item count path",
    ItemCountPathType: "Item count path type",
    ItemField: "Item field",
    ItemName: "Item name",
    ItemSingular: "Item singular",
    Items: "Items",
    ItemsProducts: "Items / Products",
    Job: "Job",
    JobDetails: "Job details",
    JobSettings: "Job settings",
    JobType: "Job type",
    Jobs: "Jobs",
    Join: "Join",
    JoinedLists: "Joined lists",
    JoinFields: "Join fields",
    JoinFromTable: "Join from table",
    JoinSettings: "Join settings",
    JoinType: "Join type",
    Joins: "Joins",
    Json: "JSON",
    JsonPath: "JSON path",
    JsonSchema: "JSON schema",
    JustMe: "Just me",
    KeepGoing: "Keep going",
    KeepSubscription: "Keep subscription",
    Key: "Key",
    KeyFields: "Key fields",
    KnowledgeBase: "Knowledge base",
    KnowledgeBases: "Knowledge bases",
    KpiTile: "KPI tile",
    Label: "Label",
    LabelTemplate: "Label template",
    Labels: "Labels",
    Large: "Large",
    Last12Months: "Last 12 months",
    LastCallDate: "Last call date",
    LastDayOfMonth: "Last day of the month",
    LastLogin: "Last login",
    LastMonth: "In the last month",
    LastName: "Last name",
    LastPublish: "Last publish",
    LastUpdateTime: "Last update time",
    LastUsed: "Last used",
    LastWeek: "In the last week",
    LateFailure: "Late failure",
    Later: "I'll do this later",
    Layout: "Layout",
    Left: "Left",
    LeftBorder: "Left border",
    LegacyMigration: "Legacy migration",
    LegacySource: "Legacy source",
    Length: "Length",
    Lessons: "Lessons",
    LetsGetStarted: "Let's get started",
    License: "License",
    LikeFacebook: "Like us on Facebook",
    LineColor: "Line color",
    LineSpacing: "Line spacing",
    LineStyle: "Line style",
    LineThickness: "Line thickness",
    Link: "Link",
    Linkedin: "LinkedIn",
    LinkToEntity: "Link to list",
    LinkedToConnector: "Linked to connector",
    LinkedToEntity: "Linked to list",
    LinkedTool: "Linked tool",
    Links: "Links",
    List: "List",
    ListActionSettings: "List action settings",
    ListItems: "List items",
    ListResponse: "List response",
    Lists: "lists",
    ListType: "List type",
    ListValues: "List values",
    ListsReady: "Lists ready",
    LoadingAnimation: "Loading animation",
    LoadListItems: "Dynamically load list items from another list",
    LoadListItemsFrom: "Load list items from",
    Loading: "Loading",
    LoadingLists: "Loading lists…",
    LoadingPrompts: "Loading prompts…",
    LoadingTables: "Loading tables…",
    LoadingTemplates: "Loading templates…",
    LoadingTools: "Loading tools…",
    Locale: "Locale",
    LocalizeSearchResults: "Localize search results",
    Location: "Location",
    LocationRecord: "Record",
    Locked: "Locked",
    LongDescription: "Long description",
    Lookup: "Lookup",
    LookupDetails: "Lookup details",
    Lookups: "Lookups",
    LookupSettings: "Lookup settings",
    LookUpValueList: "Look up the value from a list",
    MainQuery: "Main query",
    MakeBackup: "Make backup",
    MakePrimary: "Make primary",
    MakeSelectionBold: "Make selection bold",
    MakeSelectionItalics: "Make selection italics",
    ManagePaymentAndBilling: "Manage payment & billing",
    ManagePaymentBilling: "Manage payment & billing →",
    ManageRecipients: "Manage recipients",
    ManageTabs: "Manage tabs...",
    ManageTabsTitle: "Manage tabs",
    Mapping: "Mapping",
    Margin: "Margin",
    Margins: "Margins",
    Markdown: "Markdown",
    MatchingFields: "Matching fields",
    MatrixColumnSettings: "Matrix column settings",
    MatrixRowSettings: "Matrix row settings",
    MaxCategories: "Maximum number of categories",
    MaxFileSizeMb: "Max file size (MB)",
    MaximumRetries: "Maximum retries",
    MaxNumberFiles: "Max number of files",
    MaxReasoningTokens: "Max reasoning tokens",
    MaxRecords: "Max records",
    MaxResults: "Max results",
    MaxRetries: "Maximum number of retries",
    MaxTokens: "Max tokens",
    MaxUses: "Max uses",
    MaxWords: "Maximum number of words",
    Mcp: "MCP",
    McpClientDetails: "MCP client details",
    McpClients: "MCP clients",
    McpClientSettings: "MCP client settings",
    McpIcons: "MCP icons",
    McpIconSettings: "MCP icon settings",
    McpPromptExecutions: "MCP prompt executions",
    McpPrompts: "MCP prompts",
    McpPromptSettings: "MCP prompt settings",
    McpResourceSettings: "MCP resource settings",
    McpServer: "MCP server",
    McpServerConfigured: "MCP server configured",
    McpServerLive: "MCP server live",
    McpServerName: "MCP server name",
    McpServers: "MCP servers",
    McpTool: "MCP tool",
    McpToolCompany: "MCP tool company",
    McpToolExecutions: "MCP tool executions",
    McpToolResponseFields: "MCP tool response fields",
    McpTools: "MCP tools",
    McpToolSettings: "MCP tool settings",
    McpWidgets: "MCP widgets",
    McpWidgetSettings: "MCP widget settings",
    McpWidgetThemes: "MCP widget themes",
    McpWidgetThemeSettings: "MCP widget theme settings",
    MergeListsToCreate: "Merge lists to create",
    MergedLists: "Merged lists",
    Messages: "Messages",
    MessageSettings: "Message settings",
    MessagingTemplates: "Messaging templates",
    MigratingData: "Migrating your data",
    MigrationComplete: "Migration complete",
    MigrationConnectorOptional: "Migration connector (optional)",
    MigrationPlan: "Migration plan",
    MigrationStarted: "Migration started",
    MinWordCount: "Minimum word count",
    Medium: "Medium",
    Members: "Members",
    MergeFields: "Merge fields",
    Message: "Message",
    Metadata: "Metadata",
    Method: "Method",
    Mfa: "MFA",
    MfaEnabledFor: "Enabled for",
    MfaOptionAllAdmins: "Enabled for all administrators",
    MfaOptionAllUsers: "Enabled for all users",
    MfaOptionNotEnabled: "Not enabled",
    MfaOptionSelectedRoles: "Enabled for selected roles",
    MfaOptionSelectedTeams: "Enabled for selected teams",
    MfaOptionSelectedUsers: "Enabled for selected users",
    MinimumPasswordLength: "Minimum password length",
    Minutes: "Minutes",
    MobileApp: "Mobile app",
    MobileApps: "Mobile apps",
    MobileApps2: "Mobile Apps",
    MobileAppWidget: "Mobile app widget",
    Model: "Model",
    Models: "Models",
    ModifiedFavoriteIndicator: " (modified)",
    Monthly: "Monthly",
    MonthName: "Month name",
    MonthName2: "Month (name)",
    MonthNumber: "Month number",
    MonthlyBill: "Monthly bill",
    MonthlyCharges: "Monthly charges",
    Months: "Months",
    MonthShortName: "Month (short name)",
    MoreInfo: "More information",
    MorePagesFlag: "More pages flag",
    MoreThanMonthAgo: "More than a month ago",
    MostPopular: "Most popular",
    MostUsed: "Most used",
    Move: "Move",
    MoveAnotherTab: "Move to another tab",
    MoveDown: "Move down",
    MoveFormFields: "Move to form fields",
    MoveHidden: "Move to hidden",
    MoveLeft: "Move left",
    MoveListsGroup: "Move lists to group",
    MoveRight: "Move right",
    MoveToBottom: "Move to bottom",
    MoveToColumnNumber: "Move to column {0}",
    MoveToTop: "Move to top",
    MoveUp: "Move up",
    MoveWidget: "Move widget",
    MultiFactorAuth: "Multi-factor authentication",
    MultipleList: "Multiple list",
    Multiselect: "Multiselect",
    MultiStepForm: "Multi-step form",
    MyApps: "My apps",
    N100: "100%",
    N150: "150%",
    N25: "25%",
    N30Days: "30 days",
    N50: "50%",
    N75: "75%",
    N7Days: "7 days",
    Name: "Name",
    NameField: "Name field",
    NameFieldPath: "Name field path",
    NameTemplate: "Name template",
    NegativeField: "Negative field",
    NegativeValues: "Negative values",
    NetsuitePortlet: "Netsuite portlet",
    Never: "Never",
    NewChat: "New chat",
    NewColumnName: "New column name",
    NewConnector: "New connector",
    NewEntity: "New list",
    NewMcpServer: "New MCP server",
    NewMcpServerNamed: "{0} (new)",
    NewPassword: "New password",
    NewRowName: "New row name",
    News: "News",
    NewVersion: "New version",
    Next: "Next",
    NextBillingDate: "Next billing date",
    NextCursor: "Next cursor",
    NextPagePath: "Next page link path",
    NextPageUrl: "Next page URL",
    NextPageUrlPathType: "Next page link path type",
    NextRecordOffset: "Next record offset",
    No: "No",
    NoActions: "No actions",
    NoAdaptiveCardTemplates: "No adaptive card templates",
    NoAiToneModifiers: "No AI tone modifiers",
    NoAppRegistrations: "No app registrations",
    NoAttachments: "No attachments",
    NoBlocks: "No blocks",
    NoCalculatedFields: "No calculated fields",
    NoChangesYet: "No changes yet",
    NoClientInstructions: "No client instructions",
    NoClientMappings: "No client mappings",
    NoClientSecrets: "No client secrets",
    NoColorCoding: "No color coding",
    NoColorGradients: "No color gradients",
    NoColorPalettes: "No color palettes",
    NoColors: "No colors",
    NoColumns: "No columns",
    NoComponents: "No components",
    NoConditions: "No conditions",
    NoConnectors: "No connectors",
    NoCustomDateFilters: "No custom date filters",
    NoCustomLists: "No custom lists",
    NoDefault: "No default",
    NoDefaultFields: "No default fields",
    NoDependencies: "No dependencies",
    NoDetails: "No details",
    NoDomains: "No domains",
    NoEmailSignatures: "No email signatures",
    NoEmailTemplates: "No email templates",
    NoEndDate: "No end date",
    NoEndpoints: "No endpoints",
    NoErrorCodes: "No error codes",
    NoExcelTemplates: "No Excel templates",
    NoExternalUsers: "No external users",
    NoFavoritePrompts: "No favorite prompts",
    NoFavorites: "No favorites",
    NoFields: "No fields",
    NoFileSplits: "No file splits",
    NoFileTypeRestrictions: "No file type restrictions",
    NoFiscalPeriods: "No fiscal periods",
    NoFiscalYears: "No fiscal years",
    NoFlows: "No flows",
    NoFormWidgets: "No form widgets",
    NoGlobalVariables: "No global variables",
    NoGroups: "No groups",
    NoHeaders: "No headers",
    NoHistory: "No history",
    NoIcons: "No icons",
    NoImages: "No images",
    NoIpAddresses: "No IP addresses",
    NoItems: "No items",
    NoJobs: "No jobs",
    NoKeyFields: "No key fields",
    NoKnowledgeBases: "No knowledge bases",
    NoListItems: "No list items",
    NoLists: "No lists",
    NoLookups: "No lookups",
    NoManagementReports: "No management reports",
    NoMcpClients: "No MCP clients",
    NoMcpServers: "No MCP servers",
    NoMessages: "No messages",
    NoMobileApps: "No mobile apps",
    NoNotificationRecipients: "No recipients",
    NoOptimizations: "No optimizations",
    NoOutputFields: "No output fields",
    NoParameters: "No parameters",
    NoPdfTemplates: "No PDF templates",
    NoPrompts: "No prompts",
    NoPublicHolidays: "No public holidays",
    NoQueries: "No queries",
    NoQueryBuilderLists: "No Query Builder lists",
    NoRecordsFound: "No records found",
    NoRedactionMethods: "No redaction methods",
    NoRedirectUris: "No redirect URIs",
    NoReportingTreeItems: "No reporting tree items",
    NoReportingTrees: "No reporting trees",
    NoResources: "No resources",
    NoRestrictions: "No restrictions",
    NoReturnFields: "No return fields",
    NoRows: "No rows",
    NoRules: "No rules",
    NoScopes: "No scopes",
    NoSections: "No sections",
    NoSecurityRoles: "No security roles",
    NoSorting: "No sorting",
    NoStyles: "No styles",
    NoSvgCards: "No SVG cards",
    NoTableStyles: "No table styles",
    NoTabs: "No tabs",
    NoTags: "No tags",
    NoTeamMappings: "No team mappings",
    NoTeamMembers: "No team members",
    NoTeams: "No teams",
    NoTemplates: "No templates",
    NoThemes: "No themes",
    NothingPublish: "Nothing to publish",
    NoTokens: "No tokens",
    NoTools: "No tools",
    NoUserInputs: "No user inputs",
    NoUserMappings: "No user mappings",
    NoUsers: "No users",
    NoValidations: "No validations",
    NoVariables: "No variables",
    NoVariants: "No variants",
    NoVersions: "No versions",
    NoVirtualNetworks: "No virtual networks",
    NoWidgetGroups: "No widget groups",
    NoWidgets: "No widgets",
    None: "None",
    NoneOfThese: "I don't use any of these",
    NotAuthorized: "Not authorized",
    NotAvailable: "Not available",
    NotConfigured: "Not configured",
    NotFound: "Not found",
    NotMapped: "Not mapped",
    NotPaid: "Not paid",
    NotSelected: "Not selected",
    NotSet: "not set",
    Notes: "Notes",
    Notifications: "Notifications",
    NotificationRecipients: "Notification recipients",
    NoWidgetThemes: "No widget themes",
    NoWorksheets: "No worksheets",
    NumberActions: "Number of actions",
    NumberAiModels: "Number of AI models",
    NumberCustomLists: "Number of custom lists",
    NumberLookups: "Number of lookups",
    NumberOfColors: "Number of colors",
    NumberOfFavorites: "Number of favorites",
    NumberOfLists: "Number of lists",
    NumberOfMembers: "Number of members",
    NumberOfPeriods: "Number of periods",
    NumberOfPrompts: "Number of prompts",
    NumberOfTools: "Number of tools",
    NumberOfVersions: "Number of versions",
    NumberQueryBuilderLists: "Number of query builder lists",
    NumberType: "Number type",
    OAuthSettings: "OAuth settings",
    OAuthState: "State",
    OData: "OData",
    ODataService: "OData service",
    ODataVersion: "OData version",
    OK: "OK",
    OldPassword: "Old password",
    OnboardingGoal: "Onboarding goal",
    OneTime: "One-time",
    OnlyDetails: "Only display in details",
    OnlyReturnSingleRecord: "Only return a single record",
    OnlyReturnSingleValue: "Only return a single value",
    Open: "Open",
    OpenAWebsite: "Open a website",
    OpenConnector: "Open your connector",
    OpenInNewTab: "Open in new tab",
    OpenWebsite: "Open website",
    Operators: "Operators",
    Optimization: "Optimization",
    OptionalAddOns: "Optional add-ons",
    OptionalParameters: "Optional parameters",
    OptionalSkipIfNotNeeded: "Optional - skip if not needed",
    Options: "Options",
    Order: "Order",
    Orientation: "Orientation",
    OthersChartCategory: "Others",
    Output: "Output",
    OutputField: "Output field",
    OutputType: "Output type",
    OverBy: "Over by",
    OverPlanAllowance: "Over plan allowance",
    OverwriteSecurity: "Overwrite existing security settings",
    OwnedUser: "Owned by user",
    Owner: "Owner",
    PageCountPath: "Page count path",
    PageCountPathType: "Page count path type",
    PageName: "Page name",
    PageNumber: "Page number",
    PageNumberType: "Page number type",
    PageOffsetPath: "Page offset path",
    PageOffsetParameter: "Page offset parameter",
    PageOffsetParameterType: "Page offset parameter type",
    PageOffsetPathType: "Page offset path type",
    PageParameter: "Page parameter",
    PageParameterType: "Page parameter type",
    PageSettings: "Page settings",
    PageSize: "Page size",
    PageSizeParameter: "Page size parameter",
    PageSizeParameterType: "Page size parameter type",
    Pages: "Pages",
    PagesRequestedAtOnce: "Pages requested at once",
    Paging: "Paging",
    PagingMethod: "Paging method",
    PagingMethodCustom: "Custom",
    PagingMethodItemCount: "Item count",
    PagingMethodNextLink: "Next page link",
    PagingMethodNone: "None",
    PagingMethodPageCount: "Page count",
    PagingMethodPageOffset: "Page offset",
    PagingMethodNextPage: "Next page number",
    PagingParameters: "Paging parameters",
    PagingMethodCursor: "Cursor",
    PagingPaths: "Paging paths",
    PagingTokenExpiryAfterRequest: "After each request",
    PagingTokenExpiryAfterTime: "After time period",
    PagingTokenExpiryBeforeRequest: "Before each request",
    PagingTokenExpiryNever: "Never",
    PagingTokenExpiryOnError: "On error",
    PagingTokenExpiryTokenPath: "After time period from token response",
    Paid: "Paid",
    PaperSize: "Paper size",
    Paragraph: "Paragraph",
    Parameter: "Parameter",
    ParameterDetails: "Parameter details",
    ParameterMapping: "Parameter mapping",
    ParameterName: "Parameter name",
    ParameterSettings: "Parameter settings",
    ParameterType: "Parameter type",
    Parameters: "Parameters",
    Parent: "Parent",
    ParentCompanyLabel: "Parent company label",
    ParentEntity: "Parent list",
    ParentFields: "Parent fields",
    ParentGroup: "Parent group",
    ParentKnowledgeBase: "Parent knowledge base",
    PartnerUsers: "Partner users",
    Password: "Password",
    Password2: "password",
    PasswordCannotContainRepeats: "Password cannot contain repeated characters",
    PasswordCannotContainSequences: "Password cannot contain sequences (eg 12345 or abcde)",
    PasswordExpires: "Password expires",
    PasswordExpiryDays: "Password expiry days",
    PasswordMustContainLowercase: "Password must contain at least one lowercase character",
    PasswordMustContainNonAlpha: "Password must contain at least one non-alphanumeric character",
    PasswordMustContainNumber: "Password must contain at least one numeric character",
    PasswordMustContainUppercase: "Password must contain at least one uppercase character",
    PasswordPolicy: "Password policy",
    PasswordPreventReuse: "Prevent password reuse",
    PasswordsToRemember: "Number of passwords to remember",
    PastDue: "Past due",
    Path: "Path",
    Payment: "Payment",
    PaymentDue: "Payment due",
    PaymentFailed: "Payment failed",
    PaymentFailedForInvoice: "Payment failed for invoice #{0}",
    PaymentMethod: "Payment method",
    PaymentMethods: "Payment methods",
    PaymentReversal: "Payment reversal",
    Payments: "Payments",
    Pdf: "PDF",
    PdfDocuments: "PDF Documents",
    PdfExportOptions: "PDF export options",
    PdfSettings: "PDF settings",
    PdfTemplates: "PDF templates",
    Pending: "Pending",
    PendingConnectors: "Pending connectors",
    PendingEntities: "Pending lists",
    Period: "Period",
    PeriodNumber: "Period number",
    Periods: "Periods",
    Permission: "Permission",
    Permissions: "Permissions",
    PerMonth: "per month",
    PerMonthAbbreviated: "/ mo",
    PerMonthShort: "/ month",
    PerYear: "per year",
    PerYearAbbreviated: "/ yr",
    PhoneNumber: "Phone number",
    PhoneNumberCleansing: "Phone number cleansing",
    PickAFormToEmbed: "Pick a form to embed",
    PickAWidgetToEmbed: "Pick a widget to embed",
    PickOne: "Pick one",
    PickYourAdHocReportingTemplates: "Pick your ad-hoc reporting templates",
    PickYourConnectors: "Pick your connectors",
    PivotTable: "Pivot table",
    Placeholder: "Placeholder",
    Placeholders: "Placeholders",
    PlaceholderUsers: "{0} users",
    Plan: "Plan",
    PlanChange: "Plan change",
    PlanChangeFailed: "Plan change failed",
    PlanEndsOn: "{0} · ends {1}",
    PlanEssentials: "Essentials",
    PlanFeature100Users: "Up to 100 users",
    PlanFeature10Connectors: "10 data connectors",
    PlanFeature25Favorites: "25 saved favorites",
    PlanFeature25Users: "Up to 25 users",
    PlanFeature3Connectors: "3 data connectors",
    PlanFeature5Users: "Up to 5 users",
    PlanFeatureDashboardTiles: "Dashboard tiles & scheduling",
    PlanFeatureEmailSupport: "Email support",
    PlanFeatureExcelPdfExport: "Excel & PDF export",
    PlanFeatureMcpServers: "MCP servers & AI tools",
    PlanFeaturePrioritySupport: "Priority support",
    PlanFeatureSso: "SSO / SAML provisioning",
    PlanFeatureSuccessManager: "Dedicated success manager",
    PlanFeatureUnlimitedConnectors: "Unlimited connectors",
    PlanFeatureUnlimitedFavorites: "Unlimited favorites",
    PlanFeatureUnlimitedUsers: "Unlimited users",
    PlanLimit: "Plan limit",
    PlanPremium: "Premium",
    PlanPrice: "Plan price",
    PlanProfessional: "Professional",
    PlanRenewsOn: "{0} · renews {1}",
    PlanUnchanged: "{0} (unchanged)",
    PlanUsage: "Plan usage",
    PlanUsedUp: "Plan allowance used up",
    Points: "Points",
    PopdockDocumentation: "Popdock documentation",
    PopdockDynamics365BusinessCentral: "Popdock for Dynamics 365 Business Central",
    PopdockScript: "Popdock script",
    PopdockScriptDocumentation: "Popdock script documentation",
    PopdockTeam: "Popdock team",
    PopdockUser: "Popdock user",
    PopdockUserTeam: "Popdock user/team",
    PopdockZendesk: "Popdock for Zendesk",
    Popular: "Popular",
    Position: "Position",
    PostalCode: "Postal code",
    PreviousMonth: "Last month",
    PricingPolicy: "pricing policy",
    Posted: "Posted",
    PowerApps: "Power apps",
    PrepareLists: "Prepare your lists",
    PreProcessing: "Pre-processing",
    Preferences: "Preferences",
    Preview: "Preview",
    PreviewFirstEmail: "Preview the first email",
    PreviewFirstSummary: "Preview the first summary",
    Previous: "Previous",
    Primary: "Primary",
    Process: "Process",
    ProcessDataBatches: "Process data in batches",
    Processes: "Processes",
    ProcessFailed: "Your Process Failed to run",
    ProductAddress1: "1826 Kramer Lane",
    ProductAddress2: "Suite E",
    ProductAddress3: "Austin, TX 78758",
    ProductDocumentation: "Product documentation",
    ProductName: "Popdock",
    Profile: "Profile",
    ProfilePicture: "Profile picture",
    ProfileType: "Profile type",
    Progress: "Progress",
    ProjectedEndOfMonth: "Projected end of month",
    Prompt: "Prompt",
    PromptDetails: "Prompt details",
    Prompts: "Prompts",
    Prompts2: "prompts",
    PromptsToExpose: "Prompts to expose",
    Properties: "Properties",
    Property: "Property",
    ProratedToday: "prorated today",
    PrototypeState: "Prototype state",
    Public: "Public",
    PublicHolidays: "Public holidays",
    Publish: "Publish",
    Published2: "Published by",
    PublishedConnectors: "Published connectors",
    PublishError: "Publish error",
    PublishErrors: "Publish errors",
    PublishResources: "Publish resources",
    PublishSkill: "Publish skill",
    PublishSuccessful: "Publish successful",
    PublishVersion: "Publish version",
    PublishWidget: "Publish widget",
    Published: "Published",
    PublishedWidgets: "Published widgets",
    Publisher: "Publisher",
    Queries: "Queries",
    Query: "Query",
    QueryBuilder: "Query builder",
    QueryBuilderLists: "Query builder lists",
    QueryBuilderLists2: "Query Builder lists",
    QueryData: "Query data",
    QueryEditor: "Query editor",
    QueryEngine: "Query engine",
    QueryEngineUrl: "Query engine URL",
    QueryField: "Query field",
    QueryGenerator: "Query generator",
    QueryOptimization: "Query optimization",
    QueryString: "Query string",
    Queue: "Queue",
    QuickCapture: "Quick capture",
    Range: "Range",
    Reactivate: "Reactivate",
    ReactivateUser: "Reactivate user",
    ReadFrom: "Read from",
    ReadMcpSetupGuide: "Read the MCP setup guide",
    ReadOnly: "Read only",
    ReadingListSchema: "Reading list schema",
    ReasoningEffort: "Reasoning effort",
    ReasoningSummary: "Reasoning summary",
    ReasoningTokens: "Reasoning tokens",
    ReAuthenticate: "Re-authenticate",
    Recalculate: "Recalculate",
    RecentlyAdded: "Recently added",
    RecentlyClosedTabs: "Recently closed tabs",
    RecentlyUsed: "Recently used",
    RecentlyUsedFavorites: "Recently used favorites",
    Recipient: "Recipient",
    Recipients: "Recipients",
    RecipientType: "Recipient type",
    Reconnect: "Reconnect",
    Record: "record",
    RecordOffset: "Record offset",
    Records: "records",
    RecordsPerPage: "Records per page",
    RecordsTable: "Records table",
    RedactedOutput: "Redacted output",
    Redaction: "Redaction",
    RedactionMethodDetails: "Redaction method details",
    RedactionMethods: "Redaction methods",
    Redactions: "Redactions",
    RedactionSettings: "Redaction settings",
    RedactWordsSeparately: "Redact words separately",
    RedactionMethod: "Redaction method",
    RedirectUri: "Redirect URI",
    RedirectUris: "Redirect URIs",
    ReferenceNumber: "Reference number",
    Refresh: "Refresh",
    RefreshAll: "Refresh all",
    RefreshMethod: "Refresh method",
    RefreshMethodAfterRequest: "After each request",
    RefreshMethodAfterTimeExpires: "After time period expires",
    RefreshMethodBeforeRequest: "Before each request",
    RefreshMethodNone: "None",
    RefreshMethodOnError: "On error",
    RefreshToken: "Refresh token",
    RefreshTokenLength: "Length",
    RefreshTokenUnit: "Unit",
    RefreshTokenUrl: "Refresh token URL",
    Refund: "Refund",
    RegenerateSecret: "Regenerate secret",
    Region: "Region",
    RegularExpression: "Regular expression",
    RejectionDetails: "Rejection details",
    Related: "Related",
    RelatedList: "Related list",
    Relationships: "Relationships",
    RelativeDate: "Relative date",
    Reload: "Reload",
    ReloadThePage: "Reload the page",
    RemoteMcpServerUrl: "Remote MCP server URL",
    Remove: "Remove",
    RemoveAction: "Remove action",
    RemoveAttachment: "Remove attachment",
    RemoveBlankLinesAdditionalSpaces: "Remove blank lines and additional spaces",
    RemoveBlanks: "Remove blanks",
    RemoveBlankValues: "Remove blank values",
    RemoveConnector: "Remove connector",
    RemoveCustomScript: "Remove custom script",
    RemoveEmptyObjects: "Remove empty objects",
    RemoveEmptyProperties: "Remove empty properties",
    RemoveEntity: "Remove list",
    RemoveFilter: "Remove filter",
    RemoveParameterIfValueEmpty: "Remove parameter if value is empty",
    RemoveProfilePicture: "Remove profile picture",
    RemoveTab: "Remove tab",
    RemoveTeam: "Remove team",
    RemoveTeamMember: "Remove team member",
    RemoveUser: "Remove user",
    RemoveUserFromRole: "Remove user from role",
    RemoveUserFromTeam: "Remove user from team",
    RemoveWhenEmpty: "Remove when empty",
    RemoveWhenEmptyValue: "Remove parameter from query if value is empty",
    RemoveWidgetFromApp: "Remove widget from app",
    Renews: "Renews",
    Repair: "Repair",
    Replace: "Replace",
    ReplaceCreditCard: "Replace credit card",
    ReplaceExisting: "Replace existing",
    ReplaceListItems: "Replace existing list items",
    ReplacementCharacter: "Replacement character",
    ReplacementType: "Replacement type",
    Report: "Report",
    ReportingTree: "Reporting tree",
    ReportingTreeType: "Reporting tree type",
    ReportingTrees: "Reporting trees",
    Reports: "Reports",
    Request: "Request",
    RequestBody: "Request body",
    RequestMethod: "Request method",
    RequestMethodDelete: "Delete",
    RequestMethodGet: "Get",
    RequestMethodInherit: "Inherit from connector",
    RequestMethodPatch: "Patch",
    RequestMethodPost: "Post",
    RequestMethodPut: "Put",
    RequiredBy: "Required by {0}",
    RequiredField: "Required field",
    RequireOwnCredentials: "Require each user to sign in with their own credentials",
    RequireUserTokens: "Require tokens for each user",
    Required: "Required",
    RequiredParameters: "Required parameters",
    RequiredPlaceholder: "{0} is required",
    Requirements: "Requirements",
    Requires: "Requires",
    ResendInvitation: "Resend invitation email",
    Reset: "Reset",
    ResetDefaults: "Reset to default",
    ResetOnboardingDev: "Reset onboarding (dev)",
    ResetPassword: "Reset password",
    Resets: "Resets",
    ResetTableDefaultState: "Reset table to the default state",
    Resources: "Resources",
    Response: "Response",
    ResponseCode: "Response code",
    ResponseFields: "Response fields",
    ResponseSorts: "Response sorts",
    ResponseType: "Response type",
    Resubscribe: "Resubscribe",
    Rest: "REST",
    RestDateFormatCustom: "Custom",
    RestDateFormatEpochMilliseconds: "Epoch milliseconds",
    RestDateFormatEpochSeconds: "Epoch seconds",
    RestDateFormatIso8601: "ISO 8601",
    RestOptimizationEndpoint: "Endpoint query mapping",
    RestOptimizationGraphQL: "GraphQL",
    RestOptimizationNone: "None",
    RestOptimizationOData: "OData",
    RestoreVersion: "Restore this version",
    RestResponse: "REST response",
    RestSettings: "REST settings",
    Restore: "Restore",
    Restriction: "Restriction",
    RestrictionType: "Restriction type",
    Restrictions: "Restrictions",
    ResubmitApp: "Resubmit app",
    Result: "Result",
    Resume: "Resume",
    ResumeFailed: "Resume failed",
    ResumeSubscription: "Resume subscription",
    Retry: "Retry",
    RetryErrorCodes: "Retry error codes",
    RetryOnError: "Retry on error",
    RetrySleepTime: "Sleep time between retries (milliseconds)",
    RetryUpload: "Retry upload",
    ReturnAllFiles: "Return all files",
    ReturnFields: "Return fields",
    ReturnFieldSettings: "Return field settings",
    ReturnHomePage: "Return to your home page",
    ReturnHomePage2: "Return to your home page.",
    RetypePassword: "Retype password",
    Reveal: "Reveal",
    ReverseSign: "Reverse sign",
    RevertFavorite: "Revert to saved favorite",
    ReviewAndConfirm: "Review and confirm",
    ReviewYourMigration: "Review your migration",
    Revoke: "Revoke",
    Revoked: "Revoked",
    RevokeSecret: "Revoke secret",
    Right: "Right",
    RightBorder: "Right border",
    RightClickMenu: "Right-click menu",
    Role: "Role",
    RoleDescription: "Role description",
    RoleName: "Role name",
    RoleSettings: "Role settings",
    Roles: "Roles",
    RollBack: "Roll back",
    RollBackVersion: "Roll back to this version",
    RootPath: "Root path",
    RollingValue: "Rolling value",
    RoundingMethod: "Rounding method",
    Row: "Row",
    RowToDuplicate: "Row to duplicate",
    Rows: "Rows",
    Rule: "Rule",
    Rules: "Rules",
    Run: "Run",
    RunAction: "Run action",
    RunADatabaseAction: "Run a database action",
    RunAgain: "Run again",
    RunAPreDefinedConnectorAction: "Run a pre-defined connector action",
    RunAStoredProcedure: "Run a stored procedure",
    RunAWorkflow: "Run a workflow",
    RunCalculation: "Run calculation",
    RunIntegration: "Run Integration",
    RunMigration: "Run migration",
    RunProcessOnAll: "Run Processes on all",
    RunProcesses: "Run Processes",
    RunJobAt: "Run job at",
    RunNow: "Run now",
    RunQuery: "Run query",
    RunToolThirdPartyMcpServer: "Run a tool from a third-party MCP server",
    SalesforcePage: "Visualforce page",
    SalesOrders: "Sales orders",
    Salespeople: "Salespeople",
    SampleFile: "Sample file",
    SampleText: "Sample text",
    Sandbox: "Sandbox",
    SandboxConnector: "Sandbox connector",
    Sandboxes: "Sandboxes",
    SankeyCategoryFields: "Category fields",
    Save: "Save",
    SaveAndContinue: "Save and continue",
    SaveAsDraft: "Save as draft",
    SaveAsNewFavorite: "Save as new favorite",
    SaveChanges: "Save changes",
    SaveFavorite: "Save favorite",
    SaveFile: "Save as a file",
    SavePercent: "Save {0}%",
    SaveVisualforcePage: "Save Visualforce page",
    SavingSchedule: "Saving schedule",
    Schedule: "Schedule",
    ScheduleSaved: "Schedule saved",
    ScheduleYourFirstAiSummary: "Schedule your first AI summary",
    ScheduleYourFirstEmail: "Schedule your first email",
    ScheduledAiSummaries: "Scheduled AI summaries",
    ScheduledEmailAttachment: "Scheduled email with attachment",
    ScheduleFavorite: "Schedule favorite",
    ScheduleFirstRun: "Schedule first run",
    Scheduler: "Scheduler",
    Schedules: "Schedules",
    SchedulingAiSummary: "Scheduling your AI summary",
    Schema: "Schema",
    SchemaSyncMode: "Schema sync mode",
    Scope: "Scope",
    ScopeAuthor: "Build and configure (author)",
    ScopeConsume: "Use and run (consume)",
    ScopeMcp: "MCP client access (mcp)",
    ScopeOpenId: "Sign in (openid)",
    Scopes: "Scopes",
    ScopeUserProfile: "User profile (user)",
    Script: "Script",
    ScriptEntities: "Script entities",
    ScrollLeft: "Scroll left",
    ScrollRight: "Scroll right",
    Search: "Search",
    SearchField: "Search field",
    SearchKnowledgeBase: "Search knowledge base",
    SearchLookup: "Search lookup",
    Second: "Second",
    Seconds: "Seconds",
    Secret: "Secret",
    Sections: "Sections",
    Security: "Security",
    SecurityCode: "Security code",
    SecurityPermissions: "Security permissions",
    Select: "Select",
    SelectAccount: "Select account",
    SelectAccountCategory: "Select account category",
    SelectAccountSubcategory: "Select account subcategory",
    SelectAction: "Select action",
    SelectActionType: "Select action type",
    SelectAddressType: "Select address type",
    SelectAiConnector: "Select AI connector",
    SelectAll: "Select all",
    SelectApp: "Select app",
    SelectApplication: "Select application",
    SelectApplications: "Select applications",
    SelectARecipient: "Select a recipient",
    SelectAttachment: "Select attachment",
    SelectAttachmentType: "Select attachment type",
    SelectAvailability: "Select availability",
    SelectBarcodeType: "Select barcode type",
    SelectBaseTimeUnit: "Select base time unit",
    SelectBodyType: "Select body type",
    SelectCategory: "Select category",
    SelectChartType: "Select chart type",
    SelectChildCompany: "Select child company",
    SelectChunkStrategy: "Select chunk strategy",
    SelectClient: "Select client",
    SelectColor: "Select color",
    SelectColumn: "Select column",
    SelectColumns: "Select columns",
    SelectColumnType: "Select column type",
    SelectCompany: "Select company",
    SelectCompanyPlaceholder: "Select {0}",
    SelectComparison: "Select comparison",
    SelectComparisonField: "Select comparison field",
    SelectComparisonType: "Select comparison type",
    SelectConnector: "Select connector",
    SelectConnectorCategory: "Select connector category",
    SelectCountry: "Select country",
    SelectCurrency: "Select currency",
    SelectDatabase: "Select database",
    SelectDatabases: "Select databases",
    SelectDataSource: "Select data source",
    SelectDate: "Select date",
    SelectDateFormat: "Select date format",
    SelectDateGranularity: "Select date granularity",
    SelectDateType: "Select date type",
    SelectDateValue: "Select date value",
    SelectDayOfWeek: "Select day of week",
    SelectDaysOfMonth: "Select days of the month",
    SelectDaysOfWeek: "Select days of the week",
    SelectDefaultValue: "Select default value",
    SelectDependency: "Select a dependency",
    SelectDestination: "Select destination",
    SelectDetail: "Select detail",
    SelectDimension: "Select dimension",
    SelectDirection: "Select direction",
    SelectDisplayTimeUnit: "Select display time unit",
    SelectDisplayType: "Select display type",
    SelectEmailFormat: "Select email format",
    SelectEntities: "Select lists",
    SelectEntity: "Select list",
    SelectEnvironment: "Select environment",
    SelectErrorCode: "Select error code",
    SelectEvent: "Select event",
    SelectFavorite: "Select favorite",
    SelectFavorites: "Select favorites",
    SelectField: "Select field",
    SelectFieldLanguage: "Select field language",
    SelectFieldType: "Select field type",
    SelectFields: "Select fields",
    SelectFile: "Select file",
    SelectFileFormat: "Select file format",
    SelectFilterType: "Select filter type",
    SelectFiscalPeriod: "Select fiscal period",
    SelectFiscalYearOrPeriod: "Select fiscal year or period",
    SelectFlow: "Select flow",
    SelectFolder: "Select folder",
    SelectFont: "Select font",
    SelectForm: "Select form",
    SelectFunction: "Select function",
    SelectGenerationMethod: "Select generation method",
    SelectGridColumnSizingMethod: "Select a column sizing method",
    SelectGroup: "Select group",
    SelectIcon: "Select icon",
    SelectImage: "Select image",
    SelectImportMethod: "Select the import method:",
    SelectIntegration: "Select integration",
    SelectKnowledgeBase: "Select knowledge base",
    SelectLocale: "Select locale",
    SelectLocation: "Select location",
    SelectLookup: "Select lookup",
    SelectMcpServer: "Select MCP server",
    SelectMembers: "Select members",
    SelectMethod: "Select method",
    SelectModel: "Select model",
    SelectNone: "Select none",
    SelectOutputType: "Select output type",
    SelectParameter: "Select parameter",
    SelectParameterType: "Select parameter type",
    SelectPath: "Select path",
    SelectPathType: "Select path type",
    SelectProcess: "Select process",
    SelectProfileType: "Select profile type",
    SelectProperty: "Select property",
    SelectQuery: "Select query",
    SelectReport: "Select report",
    SelectReportType: "Select report type",
    SelectRequestMethod: "Select request method",
    SelectResourceType: "Select resource type",
    SelectResources: "Select resources",
    SelectResponseType: "Select response type",
    SelectRestrictionType: "Select restriction type",
    SelectRoles: "Select roles",
    SelectRows: "Select rows",
    SelectRowType: "Select row type",
    SelectSandbox: "Select sandbox",
    SelectServer: "Select server",
    SelectSidebar: "Select sidebar",
    SelectSortField: "Select sort field",
    SelectStage: "Select stage",
    SelectStatus: "Select status",
    SelectStoredProcedure: "Select stored procedure",
    SelectStyle: "Select style",
    SelectSummaryMethod: "Select summary method",
    SelectTab: "Select tab",
    SelectTable: "Select table",
    SelectTables: "Select tables",
    SelectTabsToClose: "Select tabs to close",
    SelectTag: "Select tag",
    SelectTeam: "Select team",
    SelectTeamMembers: "Select team members",
    SelectTeams: "Select teams",
    SelectTemplate: "Select template",
    SelectTextFormat: "Select text format",
    SelectTheme: "Select theme",
    SelectTileType: "Select tile type",
    SelectTimeZone: "Select time zone",
    SelectTokenExpiryMethod: "Select token expiry method",
    SelectToneModifier: "Select tone modifier",
    SelectTool: "Select tool",
    SelectType: "Select type",
    SelectUnitType: "Select unit type",
    SelectUser: "Select user",
    SelectUsers: "Select users",
    SelectValidationType: "Select validation type",
    SelectValue: "Select value",
    SelectValues: "Select values",
    SelectValueType: "Select value type",
    SelectVariable: "Select variable",
    SelectVirtualNetwork: "Select virtual network",
    SelectWidget: "Select widget",
    Selected: "Selected",
    SelectWorkflow: "Select workflow",
    Send: "Send",
    SendAnApiRequest: "Send an API request",
    SendAs: "Send as",
    SendEmail: "Send email",
    SendInvitesAndContinue: "Send invites & continue",
    SendTestEmailNow: "Send a test email now",
    SendUsAnEmail: "Send us an email",
    Server: "Server",
    ServerCreated: "Server created",
    ServerDetails: "Server details",
    ServerName: "Server name",
    ServerUrl: "Server URL",
    Service: "Service",
    SessionTimeout: "Session timeout (minutes)",
    SetAsRootPath: "Set as root path",
    SetUpAnAction: "Set up an action",
    SetUpConnectorNamed: "Set up {0}",
    SetUpYourConnectors: "Set up your connectors",
    SettingUpLists: "Setting up lists",
    SettingUpScheduledEmail: "Setting up your scheduled email",
    SettingUpWorkspace: "Setting up your workspace",
    SetValueFrom: "Set value from",
    Settings: "Settings",
    Settled: "Settled",
    Setup: "Setup",
    SetupComplete: "Setup complete",
    SetValueType: "Set value type",
    SharedUser: "Shared with user",
    ShareFavorite: "Share favorite",
    ShareFavorite2: "Share favorite with",
    ShareWithTeams: "Share with teams",
    ShareWithUsers: "Share with users",
    Sharing: "Sharing",
    Shipping: "Shipping",
    ShortDescription: "Short description",
    Show: "Show",
    ShowCategoryLabels: "Show category labels",
    ShowCode: "Show code",
    ShowColumns: "Show columns",
    ShowContent: "Show content",
    ShowDebugPreview: "Show debug data",
    ShowDetails: "Show details",
    ShowFavoritesInheritedTeams: "Show favorites inherited from teams",
    ShowFieldTypes: "Show field types",
    ShowGroupingContainer: "Show grouping container",
    ShowHeaders: "Show headers",
    ShowHelp: "Show help",
    ShowInheritedUserAccess: "Show user access inherited from teams",
    ShowLegend: "Show legend",
    ShowLess: "Show less",
    ShowListPreview: "Show list",
    ShowMenu: "Show menu",
    ShowMore: "Show more",
    ShowOthers: "Show 'Others' category",
    ShowPages: "Show pages",
    ShowParameters: "Show parameters",
    ShowQueryEditor: "Show query editor",
    ShowRawResponse: "Show raw response",
    ShowRequest: "Show request",
    ShowRestPreview: "Show REST requests and responses",
    ShowRestPreviews: "Show REST requests and responses",
    ShowRolesInheritedTeams: "Show roles inherited from teams",
    ShowSearch: "Show search",
    ShowSettings: "Show settings",
    ShowValueLabels: "Show value labels",
    Sidebar: "Sidebar",
    SidebarId: "Sidebar ID",
    Sidebars: "Sidebars",
    Signature: "Signature",
    SignOut: "Sign out",
    SimulateDeclinedCard: "Simulate a declined card",
    SingleAccount: "Single account",
    SingleDateRange: "Single date range",
    SingleRecord: "Single record",
    Size: "Size",
    Skip: "Skip",
    SkipBlankDates: "Skip date fields when all values are blank",
    SkipBlankNumbers: "Skip numeric fields when all values are zero",
    SkipBlankStrings: "Skip string fields when all values are blank",
    SkipEmptyTables: "Don't upload empty tables",
    SkipNow: "Skip for now",
    SkipSetupNow: "Skip setup for now?",
    SleepTime: "Sleep time",
    Slicers: "Slicers",
    Small: "Small",
    SmartConnect: "SmartConnect",
    SmartConnectErrorDescription: "SmartConnect Error Description:",
    SmartConnectErrorId: "SmartConnect Error ID:",
    SortAscending: "Sort ascending",
    SortBy: "Sort by",
    SortByCategoryAsc: "Category (ascending)",
    SortByCategoryDesc: "Category (descending)",
    SortByConnector: "Sort by connector",
    SortByFrequentlyUsed: "Sort by frequently used",
    SortByName: "Sort by name",
    SortByRecentlyUsed: "Sort by recently used",
    SortByValueAsc: "Value (ascending)",
    SortByValueDesc: "Value (descending)",
    SortCardsBy: "Sort cards by",
    SortDescending: "Sort descending",
    SortDirection: "Sort direction",
    SortField: "Sort by field",
    SortFields: "Sort fields",
    SortTabs: "Sort tabs",
    Sorting: "Sorting",
    SortingByConnector: "Sorting by connector",
    SortingByFrequentlyUsed: "Sorting by frequently used",
    SortingByName: "Sorting by name",
    SortingByRecentlyUsed: "Sorting by recently used",
    Source: "Source",
    SourceConnector: "Source connector",
    SourceEntity: "Source list",
    Spacer: "Spacer",
    SpecialFields: "Special fields",
    SpinningUpMcpServer: "Spinning up your MCP server",
    SplitOnField: "Split on field",
    Spreadsheet: "Spreadsheet",
    SqlTablesViews: "SQL tables/views",
    Stage: "Stage",
    Start: "Start",
    StartBuilding: "Start building",
    StartColor: "Start color",
    StartDate: "Start date",
    StartDateType: "Start date type",
    StartIp: "Start IP",
    StartMonth: "Start month",
    StartSubscription: "Start subscription",
    StartTime: "Start time",
    StartUsing: "Start using Popdock",
    StartYear: "Start year",
    State: "State",
    Status: "Status",
    StatusCode: "Status code",
    StayConnectedWithoutSigningIn: "Stay connected without asking users to sign in again",
    StepXOfY: "Step {0} of {1}",
    StopSharing: "Stop sharing",
    StoredProcedure: "Stored procedure",
    Style: "Style",
    StyleColor: "Style/Color",
    Styles: "Styles",
    Subcategory: "Subcategory",
    Subfolder: "Subfolder",
    Subject: "Subject",
    Submit: "Submit",
    SubmitApp: "Submit app",
    SubmitApps: "Submit your apps",
    SubmitButtonLabel: "Submit button label",
    SubmitNewApp: "Submit a new app",
    Subscribe: "Subscribe",
    SubscribeYouTube: "Subscribe to our YouTube",
    Subscription: "Subscription",
    SubscriptionDescription: "{0} ({1} per month)",
    SubscriptionEnded: "Subscription ended",
    SubscriptionNotStarted: "Subscription not started",
    SubscriptionRequired: "Subscription required",
    Subtitle: "Subtitle",
    Subtotal: "Subtotal",
    Success: "Success",
    Successful: "% successful",
    SuggestApplication: "Suggest application",
    SuggestNewConnector: "Suggest new connector",
    Suggestion: "Suggestion",
    Summary: "Summary",
    SummaryColumnMethod: "Summary column method",
    SummaryColumnName: "Summary column name",
    SummaryColumns: "Summary columns",
    SummaryEntity: "Summary list",
    SummaryFields: "Summary fields",
    SummaryMethod: "Summary method",
    SummaryRow: "SummaryRow",
    SummaryRows: "Summary rows",
    SummaryScheduled: "Summary scheduled",
    SummaryTable: "Summary table",
    SupportUsers: "Support users",
    SvgCards: "SVG cards",
    SwaggerUrl: "Swagger URL",
    Switch: "Switch",
    SwitchAccount: "Switch account",
    SwitchAuthentication: "Switch authentication?",
    SwitchToMonthlyBilling: "Switch to monthly billing",
    SwitchToYearlyBilling: "Switch to yearly billing",
    SystemDatabase: "System database",
    SystemUser: "System",
    Tab: "Tab",
    Table: "Table",
    TableAlias: "Table alias",
    TableEntity: "Table or entity",
    TableName: "Table name",
    Tables: "Tables",
    TableSettings: "Table settings",
    TableStyles: "Table styles",
    TableSummaryMethod: "Table summary method",
    Tabs: "Tabs",
    Tag: "Tag",
    TaggedFavorites: "Tagged favorites",
    TaggedItems: "Tagged items",
    Tags: "Tags",
    Tasks: "Tasks",
    TasksByDay: "Tasks by day",
    TasksByMonth: "Tasks by month",
    TasksThisMonth: "tasks this month",
    TaskType: "Task type",
    Tax: "Tax",
    Team: "Team",
    TeamDetails: "Team details",
    TeamMappings: "Team mappings",
    TeamMembers: "Team members",
    TeamsAdd: "Teams add-in",
    TeamSettings: "Team settings",
    Teams: "Teams",
    Temperature: "Temperature",
    Template: "Template",
    TemplateBuilder: "Template builder",
    TemplateName: "Template name",
    TemplateParameter: "Template parameter",
    TemplateSettings: "Template settings",
    TemplateType: "Template type",
    Test: "Test",
    TestAction: "Test action",
    TestApiEndpoint: "Test API endpoint",
    Term: "Term",
    TestCalculation: "Test calculation",
    TestEmbed: "Test the embed",
    TestMethod: "Test method",
    Testing: "Testing",
    Text: "Text",
    TextColor: "Text color",
    TextFormat: "Text format",
    TextOptions: "Text options",
    TextSearch: "Text search",
    TextSettings: "Text settings",
    Theme: "Theme",
    ThemeForm: "Theme the form",
    Themes: "Themes",
    ThemeWidget: "Theme the widget",
    Thickness: "Thickness",
    Third: "Third",
    ThisMonth: "This month",
    Time: "Time",
    Time2: "To time",
    TimedOut: "Timed out",
    Timeline: "Timeline",
    TimePeriodDays: "Days",
    TimePeriodHours: "Hours",
    TimePeriodMinutes: "Minutes",
    TimePeriodSeconds: "Seconds",
    TimeZone: "Time zone",
    Title: "Title",
    TitleField: "Title field",
    ToCompany: "To company",
    ToDate: "To date",
    Today: "Today",
    ToEntity: "To list",
    ToField: "To field",
    Token2: "token",
    Tool: "Tool",
    ToolCreated: "Tool created",
    ToolDescription: "Tool description",
    ToolDetails: "Tool details",
    Tools2: "tools",
    ToolsAndPromptsCreated: "Tools and prompts created",
    ToolsCreated: "Tools created",
    ToolsToExpose: "Tools to expose",
    Top: "Top",
    TopBorder: "Top border",
    TopUsers: "Top users",
    ToTable: "To table",
    TotalNumberOfItems: "Total number of items",
    TotalNumberOfPages: "Total number of pages",
    TotalPerMonth: "Total per month",
    TotalPerYear: "Total per year",
    TotalStyle: "Total style",
    TotalTasks: "Total tasks",
    TotalTransactions: "Total transactions",
    ToValue: "To value",
    ToValueType: "To value type",
    Token: "Token",
    TokenExpires: "Token expires",
    TokenExpiryPath: "Token expiry path",
    TokenName: "Token name",
    TokenRequest: "Token request",
    TokenResponse: "Token response",
    TokenResponsePath: "Token response path",
    Tokens: "Tokens",
    ToneModifier: "Tone modifier",
    ToolSettings: "Tool settings",
    Toolbar: "Toolbar",
    ToolName: "Tool name",
    Tools: "Tools",
    Tooltip: "Tooltip",
    TopP: "Top-p",
    Total: "Total",
    Totals: "Totals",
    TrackingNumberField: "Tracking number field",
    TransactionDetails: "Transaction details",
    TransactionId: "Transaction ID",
    Transactions: "Transactions",
    Transfer: "Transfer",
    TransferOwnership: "Transfer ownership",
    TreatPunctuationAsWordStart: "Treat punctuation as the start of new word",
    TreatPunctuationStartNewWord: "Treat punctuation as start of new word",
    Trial: "Trial",
    TrialEndsInDays: "Trial ends in {0} days",
    TrialEndsInOneDay: "Trial ends in 1 day",
    TrialEndsToday: "Trial ends today",
    TrialExpired: "Trial expired",
    TrialExpiredDate: date =>
        `Your trial has expired!  You will not be able to login after "${date}".`,
    Trigger: "Trigger",
    TriggerEvent: "Trigger event",
    TriggerType: "Trigger type",
    TryAgain: "Try again",
    Type: "Type",
    TypePlaceholderField: "{0} field",
    Types: "Types",
    UnableChangeVersion: "Unable to change version",
    UnableDelete: "Unable to delete",
    Unauthorized: "Unauthorized",
    Underline: "Underline",
    UnderlineSelection: "Underline selection",
    Units: "Units",
    Unpublish: "Unpublish",
    UnpublishError: "Unpublish error",
    UnpublishWidget: "Unpublish widget",
    UnpublishedWidgets: "Unpublished widgets",
    UnsavedChanges: "Unsaved changes",
    Unsubscribe: "Unsubscribe",
    Unsubscribed: "Unsubscribed",
    UnsuccessfulCalls: "Unsuccessful calls",
    UnusedAmount: "Unused amount",
    Update: "Update",
    UpdateColorCodingRule: "Update color coding rule",
    UpdateCreditCard: "Update credit card",
    Updated: "Updated",
    UpdateDependency: "Update dependency",
    UpdateFields: "Update fields",
    UpdateListItems: "Update list items from connector",
    UpdatePaymentMethod: "Update payment method",
    UpdateProcess: "Update process",
    UpdateRecord: "Update record",
    Upgrade: "Upgrade",
    UpgradeSubscriptionUseFeature: "Upgrade your subscription to use this feature.",
    Upload: "Upload",
    UploadChunks: "Upload in chunks",
    UploadDatabase: "Upload whole databases",
    UploadEntity: "Upload list",
    UploadHistory: "Upload history",
    UploadImage: "Upload image",
    UploadImage2: "Upload an image",
    UploadTable: "Upload a single table",
    UploadTables: "Upload tables",
    UploadTo_: "Upload to ",
    UploadType: "Upload type",
    Url: "URL",
    UrlEncodedForm: "URL encoded form",
    UrlParameter: "URL parameter",
    UrlParameters: "URL parameters",
    UrlSource: "URL source",
    UrlValue: "URL value",
    Usage: "Usage",
    UsageHistory: "Usage history",
    UsageSummary: "Usage summary",
    UseADifferentCard: "Use a different card",
    UseAiGenerateData: "Use AI to generate data",
    UseAiGenerateList: "Use AI to generate a list",
    UseCustomDateFormat: "Use a custom date format",
    UseCustomResponseNoData: "Return a custom response when no data is returned",
    UseCustomScript: "Use custom script",
    UseHeadersFromParentAction: "Use headers from parent action",
    UseParameterGroups: "Use parameter groups",
    UseParametersFromParentAction: "Use parameters from parent action",
    UseParentList: "Use parent list",
    UserAgent: "User agent",
    UserDetails: "User details",
    UseRefreshTokens: "Use refresh tokens",
    User: "User",
    UserEmail: "User email",
    UserId: "User ID",
    UserInput: "User input",
    UserInputs: "User inputs",
    UserInputTypeConfirmation: "Confirmation",
    UserInputTypeNone: "None",
    UserInputTypeText: "Enter text",
    UserMappings: "User mappings",
    UserName: "User name",
    Username: "username",
    UserRoles: "user roles",
    UserSecurity: "User security",
    UserValues: "User values",
    UserVariable: "User variable",
    UserVariables: "User variables",
    Users: "Users",
    UsersInvited: "Users invited",
    Validate: "Validate",
    ValidateAgain: "Validate again",
    ValidateConnection: "Validate connection",
    ValidateCredentials: "Validate credentials",
    ValidateExtension: "Validate extension",
    ValidateScript: "Validate script",
    Validation: "Validation",
    ValidationRules: "Validation rules",
    ValidationSuccessful: "Validation successful",
    ValidationType: "Validation type",
    Validations: "Validations",
    Value: "Value",
    Value2: "-",
    ValueField: "Value field",
    ValueFields: "Value fields",
    ValueFrom: "Value from",
    ValueMapping: "Value mapping",
    Values: "Values",
    ValueType: "Value type",
    Variable: "Variable",
    Variables: "Variables",
    Variables2: "From variables",
    Variables3: "To variables",
    Variants: "Variants",
    Vendors: "Vendors",
    VerifyingConnection: "Verifying connection",
    Version: "Version",
    VersionBuild: "Build",
    VersionMajor: "Major",
    VersionMinor: "Minor",
    VersionNotes: "Version notes",
    VersionRevision: "Revision",
    Versions: "Versions",
    Videos: "Featured videos",
    View: "View",
    ViewFirstList: "View your first list",
    ViewInvoice: "View invoice",
    ViewMigrationLog: "View migration log",
    ViewPastRuns: "View past runs",
    ViewPdf: "View as PDF",
    ViewTable: "View as table",
    ViewType: "View type",
    VirtualNetwork: "Virtual network",
    VirtualNetworks: "Virtual networks",
    Voided: "Voided",
    Website: "Website",
    WebsiteUrl: "Website URL",
    Weight: "Weight",
    WhatPopdockWillDo: "What Popdock will do",
    WhatsYourFirstGoalWithPopdock: "What's your first goal with Popdock?",
    WhereTheDataComesFrom: "Where the data comes from",
    WhoWritesTheSummary: "Who writes the summary",
    Widget: "Widget",
    WidgetActionSettings: "Widget action settings",
    WidgetDomain: "Widget domain",
    WidgetGroups: "Widget groups",
    WidgetId: "Widget ID",
    WidgetOptionActions: "Show actions",
    WidgetOptionAddFavorite: "Add new favorites",
    WidgetOptionCollapse: "Allow collapsing of widgets",
    WidgetOptionColumns: "Show columns",
    WidgetOptionDefaultCollapse: "Collapse widget",
    WidgetOptionDetails: "Show details",
    WidgetOptionDisplayEmptyFields: "Show fields with no data",
    WidgetOptionEagerLoad: "Load data immediately",
    WidgetOptionEditFavorite: "Edit favorites",
    WidgetOptionExport: "Allow export",
    WidgetOptionFavorite: "Show favorites",
    WidgetOptionFilter: "Show filter",
    WidgetOptionFilterDescription: "Show filter description",
    WidgetOptionGroup: "Allow grouping",
    WidgetOptionGroupDisplay: "Display",
    WidgetOptionGroupFavorites: "Favorites",
    WidgetOptionGroupFeatures: "Features",
    WidgetOptionGroupFiltering: "Filtering",
    WidgetOptionPages: "Show pages",
    WidgetOptionParameterHierarchy: "Use alternative parameter groups when no data is found",
    WidgetOptionRecordCount: "Show record count",
    WidgetOptionRefresh: "Allow refresh",
    WidgetOptionRequireToken: "Require token",
    WidgetOptionSearch: "Show search",
    WidgetOptionSettings: "Show settings",
    WidgetOptionShowCompanies: "Show companies dropdown",
    WidgetOptionShowZoom: "Show zoom",
    WidgetOptionSidebar: "Display widget as sidebar",
    WidgetOptionTabLabel: "Show tab labels",
    WidgetOptionTitle: "Show title",
    WidgetOptionTotals: "Show totals",
    WidgetOptionViewType: "Change view type",
    WidgetParameterSettings: "Widget parameter settings",
    WidgetThemes: "Widget themes",
    WidgetTypeApplication: "Multiple lists",
    WidgetOptionCaseInsensitiveSearch: "Case insensitive search",
    WidgetTypeAiPrompt: "AI prompt",
    WidgetTypeAiChat: "AI chat",
    WidgetTypeCards: "Cards",
    WidgetTypeDashboard: "Dashboard",
    WidgetTypeFavorite: "Single list",
    WidgetTypeFile: "File",
    WidgetTypeForm: "Form",
    WidgetTypeImage: "Image",
    WidgetTypeSearch: "Search",
    WidgetTypeShipping: "Shipping details",
    WidgetTypeSidebar: "Widget group",
    WidgetTypeSingleton: "Single record",
    WidgetTypeSummary: "Summary",
    Widgets: "Widgets",
    Width: "Width",
    WillBeInstalled: "Will be installed",
    WordCloudFields: "Word cloud fields",
    WorkDays: "Work days",
    Workflow: "Workflow",
    Workflows: "Workflows",
    Working: "Working…",
    WorksheetName: "Worksheet name",
    Worksheets: "Worksheets",
    WorkspaceReady: "Workspace ready",
    Xml: "XML",
    Year: "Year",
    Yearly: "Yearly",
    YearlyPercentSaved: "Yearly ({0}% saved)",
    Years: "Years",
    YearToDate: "Year to date",
    Yes: "Yes",
    Yesterday: "Yesterday",
    YourAccount: "Your account",
    YourConnector: "your connector",
    YourDataSource: "your data source",
    YourDestination: "your destination",
    YourEntity: "your entity",
    YourPlan: "your plan",
    YourSource: "your source",
    YourSubscriptionEndedOn: "Your subscription ended on {0}",
    YourTrialEndedOn: "Your trial ended on {0}",
    YoureReadyToGo: "You're ready to go",
    Youtube: "YouTube",
    ZipFileName: "Zip file name",
    ZipFileName2: "ZIP file name",
    ZipFiles: "Zip files",
    ZoomIn: "Zoom in",
    ZoomOut: "Zoom out",
    _field: " field",
    _variable: " variable",
};
